import React, { useEffect, useState, useRef } from "react";
import "./MarketingLandingPage.css";

const goSignup  = () => { window.location.href = "https://track-r.pages.dev/signup"; };
const goLogin   = () => { window.location.href = "https://track-r.pages.dev/login"; };
const goPricing = () => { window.location.href = "https://track-r.pages.dev/pricing"; };

const Ico = ({ d, size = 20, color = "currentColor", sw = 1.75 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round"
    style={{ flexShrink: 0, display: "block" }}>
    <path d={d} />
  </svg>
);
const I = {
  journal:   "M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2zM22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z",
  sync:      "M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15",
  zap:       "M13 2L3 14h9l-1 8 10-12h-9l1-8z",
  chart:     "M18 20V10M12 20V4M6 20v-6",
  trending:  "M22 7l-8.5 8.5-5-5L2 17M16 7h6v6",
  book:      "M4 19.5A2.5 2.5 0 016.5 17H20M4 19.5A2.5 2.5 0 006.5 22H20V2H6.5A2.5 2.5 0 004 4.5v15z",
  calendar:  "M3 4h18v18H3zM16 2v4M8 2v4M3 10h18",
  checklist: "M9 11l3 3L22 4M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11",
  arrowR:    "M5 12h14M12 5l7 7-7 7",
  check:     "M20 6L9 17l-5-5",
  shield:    "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  crown:     "M2 20h20M5 20V10l7-7 7 7v10",
  brain:     "M9.5 2A2.5 2.5 0 017 4.5v0A2.5 2.5 0 014.5 7H4a2 2 0 000 4h.5A2.5 2.5 0 017 13.5v0A2.5 2.5 0 019.5 16a2.5 2.5 0 002.5-2.5V13a1 1 0 012 0v.5A2.5 2.5 0 0016.5 16 2.5 2.5 0 0019 13.5v0A2.5 2.5 0 0021.5 11H22a2 2 0 000-4h-.5A2.5 2.5 0 0019 4.5v0A2.5 2.5 0 0016.5 2a2.5 2.5 0 00-2.5 2.5V5a1 1 0 01-2 0v-.5A2.5 2.5 0 009.5 2z",
  pip:       "M12 12m-3 0a3 3 0 106 0 3 3 0 10-6 0",
  close:     "M18 6L6 18M6 6l12 12",
  eye:       "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 100 6 3 3 0 000-6z",
  target:    "M12 2a10 10 0 100 20A10 10 0 0012 2zM12 6a6 6 0 100 12A6 6 0 0012 6zM12 10a2 2 0 100 4 2 2 0 000-4z",
};

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible")),
      { threshold: 0.08 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);
}

function PromoBar() {
  const items = Array.from({ length: 8 });
  return (
    <div className="promo-bar" onClick={goPricing}>
      <div className="promo-track">
        {[...items, ...items].map((_, i) => (
          <span className="promo-item" key={i}>
            <span className="promo-flash"><Ico d={I.zap} size={12} color="#fff" sw={2.5} />LIFETIME SALE</span>
            Lifetime plan just <b>$99.99</b> · pay once, own it forever · limited time offer
            <Ico d={I.crown} size={13} color="#fbbf24" sw={2} />
          </span>
        ))}
      </div>
    </div>
  );
}

function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);
  return (
    <nav className={`mkt-nav ${scrolled ? "mkt-nav--scrolled" : ""}`}>
      <div className="mkt-nav__inner">
        <span className="mkt-nav__logo">TRACK<em>R</em></span>
         <div className="mkt-nav__links">
          <a href="#features" className="nav-pill">Features</a>
          <a href="#pricing" className="nav-pill nav-pill--accent">See plans</a>
          <a href="#how" className="nav-pill">How it works</a>
        </div>
        <div className="mkt-nav__ctas">
          <button className="btn-ghost" onClick={goLogin}>Log in</button>
          <button className="btn-primary" onClick={goSignup}>Get started</button>
        </div>
      </div>
    </nav>
  );
}

// ─── ROLLING STATS ───────────────────────────────────────────────
// ✏️ EDIT THESE: put your real numbers. Any stat left at 0 stays hidden.
const STATS = [
  { value: 6000,     suffix: "+", label: "Active Traders" },
  { value: 4579,     suffix: "+", label: "Positive Reviews" },
  { value: 12687967, suffix: "+", label: "Trades Analyzed" },
  { value: 0,        suffix: "+", label: "Backtests Run" },
];

function CountUp({ end, suffix = "", duration = 2200 }) {
  const [n, setN] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    let raf;
    const obs = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      obs.disconnect();
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1);
        setN(Math.round(end * (1 - Math.pow(1 - p, 3))));
        if (p < 1) raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => { obs.disconnect(); cancelAnimationFrame(raf); };
  }, [end, duration]);
  return <span ref={ref}>{n.toLocaleString()}{suffix}</span>;
}

function StatsStrip() {
  const live = STATS.filter(s => s.value > 0);
  return (
    <section className="mkt-stats">
      <div className="mkt-stats__bar">
        <span className="mkt-stats__pulse" />
        <span>Traders are logging trades right now. Start free in 30 seconds, no card needed.</span>
        <button className="btn-primary btn-sm" onClick={goSignup}>Join free →</button>
      </div>
      {live.length > 0 && (
        <div className="mkt-stats__inner">
          {live.map(s => (
            <div className="mkt-stats__item" key={s.label}>
              <span className="mkt-stats__num"><CountUp end={s.value} suffix={s.suffix} duration={s.value > 1000000 ? 3200 : 2200} /></span>
              <span className="mkt-stats__label">{s.label}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

function Hero() {
  return (
    <section className="mkt-hero">
      <div className="mkt-hero__content">
        <p className="eyebrow"><Ico d={I.pip} size={8} color="#22d3ee" sw={3} />TRADING PERFORMANCE OS</p>
        <h1 className="mkt-hero__title">Stop Guessing.<br /><em>Start Winning.</em></h1>
        <p className="mkt-hero__sub">
          Most traders lose because they repeat the same mistakes without ever seeing the pattern.
          TrackR shows you exactly why you win, why you lose, and what to fix — trade by trade.
        </p>
       <div className="mkt-hero__actions">
          <button className="btn-primary btn-lg" onClick={goSignup}>Start for free</button>
          <a href="#pricing" className="btn-outline btn-lg btn-plans">See plans</a>
          <a href="#features" className="btn-outline btn-lg">Features</a>
        </div>
        <p className="mkt-hero__note">No credit card required · Free plan forever · MT5 auto-sync included</p>
        <div className="mkt-hero__trust">
          {[
            {t:"MT5 Auto-Sync",          sub:"Trades logged the second you close them"},
            {t:"Efficiency Score",        sub:"RR + risk + psychology per trade"},
            {t:"MEQU Score",              sub:"Psychology quantified, not just tracked"},
            {t:"Expected vs Actual",      sub:"See where you leave money on the table"},
            {t:"Trade Review",            sub:"Win rate by strategy, session & emotion"},
            {t:"Backtesting",             sub:"12 strategies + bar-by-bar replay"},
          ].map(item => (
            <div key={item.t} className="mkt-hero__trust-item">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,marginTop:1}}><path d="M20 6L9 17l-5-5"/></svg>
              <div>
                <span className="mkt-hero__trust-title">{item.t}</span>
                <span className="mkt-hero__trust-sub"> — {item.sub}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mkt-hero__visual">
        <div className="hero-ss-wrap reveal">
          <div className="hero-ss__bar">
            <span className="hero-mockup__dot" style={{background:"#ef4444"}} />
            <span className="hero-mockup__dot" style={{background:"#f59e0b"}} />
            <span className="hero-mockup__dot" style={{background:"#22c55e"}} />
            <span className="hero-mockup__url">app.trackr.io · P&L Calendar</span>
            <span className="fp-live-badge" style={{marginLeft:"auto",fontSize:8}}><span className="fp-live-dot"/>MT5 LIVE</span>
          </div>
          <div className="hero-ss__frame">
            <img
              src="/screenshots/calender.png"
              alt="TrackR P&L Calendar"
              className="hero-ss__img"
              onError={e => { e.currentTarget.style.display="none"; e.currentTarget.nextSibling.style.display="flex"; }}
            />
            <div className="hero-ss__fallback">
              <div className="hero-mock-header">
                <div>
                  <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"rgba(34,211,238,0.7)",letterSpacing:"0.15em",marginBottom:4}}>● PERFORMANCE ANALYTICS</div>
                  <div style={{fontFamily:"'Syne',sans-serif",fontSize:18,fontWeight:900,color:"#dff0f8"}}>Performance <span style={{background:"linear-gradient(100deg,#22d3ee,#818cf8)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>Dashboard</span></div>
                </div>
              </div>
              <div className="hero-mock-kpis">
                {[
                  {l:"Win Rate",      v:"63.4%",   c:"#00ffaa"},
                  {l:"Net P&L",       v:"+$4,218", c:"#00ffaa"},
                  {l:"Profit Factor", v:"2.31",    c:"#00ffaa"},
                  {l:"Avg R:R",       v:"1:1.94",  c:"#e2e8f0"},
                ].map(k => (
                  <div key={k.l} className="hero-mock-kpi">
                    <span className="hero-mock-kpi__label">{k.l}</span>
                    <span className="hero-mock-kpi__val" style={{color:k.c}}>{k.v}</span>
                  </div>
                ))}
              </div>
              <div className="hero-mock-chart">
                <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"#5a8fa0",marginBottom:6}}>Cumulative P&L · All Time</div>
                <svg viewBox="0 0 420 80" width="100%" height="80" preserveAspectRatio="none">
                  <defs>
                    <linearGradient id="heroChartGrad" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="rgba(0,255,170,0.3)" />
                      <stop offset="100%" stopColor="rgba(0,255,170,0)" />
                    </linearGradient>
                  </defs>
                  {[0,20,40,60].map(y => <line key={y} x1="0" y1={y} x2="420" y2={y} stroke="rgba(56,189,248,0.06)" strokeWidth="1"/>)}
                  <path d="M0,72 L35,68 L70,62 L105,56 L140,60 L175,48 L210,40 L245,44 L280,32 L315,22 L350,16 L385,10 L420,4" fill="none" stroke="rgba(0,255,170,0.9)" strokeWidth="2"/>
                  <path d="M0,72 L35,68 L70,62 L105,56 L140,60 L175,48 L210,40 L245,44 L280,32 L315,22 L350,16 L385,10 L420,4 L420,80 L0,80Z" fill="url(#heroChartGrad)"/>
                </svg>
              </div>
              <div className="hero-mock-trades">
                {[
                  {sym:"XAUUSD", dir:"long",  pnl:"+$495", eff:94, score:96},
                  {sym:"EURUSD", dir:"long",  pnl:"+$320", eff:88, score:91},
                  {sym:"GBPJPY", dir:"short", pnl:"-$140", eff:42, score:55},
                ].map((t,i) => (
                  <div key={i} className="hero-mock-trade">
                    <span style={{fontFamily:"'Syne',sans-serif",fontSize:11,fontWeight:900,color:"#38bdf8",minWidth:52}}>{t.sym}</span>
                    <span className={t.dir==="long"?"fp-dir-long":"fp-dir-short"} style={{fontSize:8}}>{t.dir==="long"?"▲ L":"▼ S"}</span>
                    <div style={{flex:1,height:3,background:"rgba(30,41,59,0.8)",borderRadius:3,overflow:"hidden"}}>
                      <div style={{width:`${t.eff}%`,height:"100%",background:t.eff>=70?"linear-gradient(90deg,#38bdf8,#22c55e)":"linear-gradient(90deg,#f59e0b,#eab308)",borderRadius:3}}/>
                    </div>
                    <span style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"#475569"}}>{t.eff}%</span>
                    <span style={{fontFamily:"'Syne',sans-serif",fontSize:11,fontWeight:900,color:t.pnl.startsWith("+")?"#34d399":"#f87171",minWidth:44,textAlign:"right"}}>{t.pnl}</span>
                    <span style={{fontFamily:"'Syne',sans-serif",fontSize:10,fontWeight:900,padding:"1px 5px",background:"rgba(56,189,248,0.08)",border:"1px solid rgba(56,189,248,0.2)",borderRadius:4,color:"#38bdf8"}}>{t.score}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="hero-mockup__insight reveal" style={{animationDelay:"0.3s"}}>
            <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"#34d399",fontWeight:700,marginBottom:4,textTransform:"uppercase",letterSpacing:"0.1em"}}>✓ June Summary</div>
            <div style={{fontFamily:"'Inter',sans-serif",fontSize:11,color:"#94a3b8",lineHeight:1.5}}>Month P&L: <strong style={{color:"#00ffaa"}}>+$2,840</strong> · Day win rate: <strong style={{color:"#00ffaa"}}>72%</strong></div>
          </div>
        </div>
      </div>
    </section>
  );
}
  

// ─── SHARED MINI COMPONENTS ───────────────────────────────────────────────────

const MiniDonut = ({ segments, size = 44 }) => {
  const s = size;
  const cx = s / 2, cy = s / 2, r = 16, sw = 7;
  const total = segments.reduce((acc, sg) => acc + sg.pct, 0);
  let cumAngle = -Math.PI / 2;
  const arcs = segments.filter(sg => sg.pct > 0).map((sg, i) => {
    const angle = (sg.pct / total) * 2 * Math.PI;
    const sweep = Math.max(0, angle - 0.05);
    const x1 = cx + r * Math.cos(cumAngle);
    const y1 = cy + r * Math.sin(cumAngle);
    const x2 = cx + r * Math.cos(cumAngle + sweep);
    const y2 = cy + r * Math.sin(cumAngle + sweep);
    const d = `M ${x1} ${y1} A ${r} ${r} 0 ${sweep > Math.PI ? 1 : 0} 1 ${x2} ${y2}`;
    cumAngle += angle;
    return <path key={i} d={d} fill="none" stroke={sg.color} strokeWidth={sw} strokeLinecap="butt" />;
  });
  return (
    <svg width={s} height={s} viewBox={`0 0 ${s} ${s}`}>
      <circle cx={cx} cy={cy} r={r} fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth={sw} />
      {arcs}
      <text x={cx} y={cy + 4} textAnchor="middle" fill="#e2e8f0" fontSize="10" fontWeight="700" fontFamily="'DM Mono',monospace">
        {segments[0] ? segments[0].label : ""}
      </text>
    </svg>
  );
};

const RadarMini = ({ values, labels, color }) => {
  const cx = 70, cy = 70, r = 52, n = values.length;
  const pts = values.map((v, i) => {
    const a = (i * (360 / n) - 90) * Math.PI / 180;
    return [cx + (v / 100) * r * Math.cos(a), cy + (v / 100) * r * Math.sin(a)];
  });
  const rings = [0.33, 0.66, 1].map((rr, ri) => {
    const ringPts = Array.from({ length: n }, (_, i) => {
      const a = (i * (360 / n) - 90) * Math.PI / 180;
      return `${cx + r * rr * Math.cos(a)},${cy + r * rr * Math.sin(a)}`;
    }).join(" ");
    return <polygon key={ri} points={ringPts} fill="none" stroke="rgba(56,189,248,0.1)" strokeWidth={1} />;
  });
  const axes = Array.from({ length: n }, (_, i) => {
    const a = (i * (360 / n) - 90) * Math.PI / 180;
    return <line key={i} x1={cx} y1={cy} x2={cx + r * Math.cos(a)} y2={cy + r * Math.sin(a)} stroke="rgba(56,189,248,0.1)" strokeWidth={1} />;
  });
  const txtEls = labels.map((l, i) => {
    const a = (i * (360 / n) - 90) * Math.PI / 180;
    return <text key={i} x={cx + (r + 14) * Math.cos(a)} y={cy + (r + 14) * Math.sin(a) + 3} textAnchor="middle" fill="#64748b" fontSize="8" fontFamily="'DM Mono',monospace">{l}</text>;
  });
  return (
    <svg width={140} height={140} viewBox="0 0 140 140">
      {rings}
      {axes}
      <polygon points={pts.map(p => p.join(",")).join(" ")} fill={color + "22"} stroke={color} strokeWidth={1.5} />
      {txtEls}
    </svg>
  );
};

// ─── FEATURE PREVIEWS ────────────────────────────────────────────────────────

function DashboardPreview() {
  return (
    <div className="fp-wrap">
      <div className="fp-dash-header">
        <div className="fp-eyebrow-row">
          <span className="fp-pip" />
          <span className="fp-eyebrow-text">PERFORMANCE ANALYTICS</span>
        </div>
        <div className="fp-title-row">
          <span className="fp-page-title">Performance <em>Dashboard</em></span>
          <span className="fp-live-badge"><span className="fp-live-dot" />MT5 LIVE · 14 synced</span>
        </div>
      </div>

      <div className="fp-metrics-grid">
        {[
          { l: "Win Rate",        v: "63.4%",  c: "green" },
          { l: "Total P&L",       v: "+$4,218",c: "green" },
          { l: "Profit Factor",   v: "2.31",   c: "green" },
          { l: "Avg R:R",         v: "1.94",   c: ""      },
          { l: "Trade Expectancy",v: "0.82R",  c: "green" },
          { l: "Best Day",        v: "Tuesday",c: "cyan"  },
          { l: "Largest Gain",    v: "$892",   c: "green" },
          { l: "Largest Loss",    v: "-$340",  c: "red"   },
        ].map((m) => (
          <div className="fp-metric-card" key={m.l}>
            <span className="fp-metric-label">{m.l}</span>
            <span className={`fp-metric-val ${m.c}`}>{m.v}</span>
          </div>
        ))}
      </div>

      <div className="fp-chart-duo">
        <div className="fp-chart-card">
          <p className="fp-chart-title">Cumulative P&L</p>
          <p className="fp-chart-sub">Account growth trajectory</p>
          <svg viewBox="0 0 240 80" width="100%" height="80" preserveAspectRatio="none">
            <defs>
              <linearGradient id="cumGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="rgba(0,255,170,0.28)" />
                <stop offset="100%" stopColor="rgba(0,255,170,0)" />
              </linearGradient>
            </defs>
            <path d="M0,70 L24,65 L48,60 L72,55 L90,58 L110,46 L130,38 L150,44 L170,30 L195,20 L215,14 L240,6"
              fill="none" stroke="rgba(0,255,170,0.9)" strokeWidth="2" />
            <path d="M0,70 L24,65 L48,60 L72,55 L90,58 L110,46 L130,38 L150,44 L170,30 L195,20 L215,14 L240,6 L240,80 L0,80Z"
              fill="url(#cumGrad)" />
          </svg>
        </div>

        <div className="fp-chart-card">
          <p className="fp-chart-title">Daily Net P&L</p>
          <p className="fp-chart-sub">Day-by-day realized P&L</p>
          <svg viewBox="0 0 240 80" width="100%" height="80">
            {[
              [14,28,"rgba(0,255,170,0.75)"],[34,14,"rgba(255,85,128,0.75)"],
              [54,38,"rgba(0,255,170,0.75)"],[74,52,"rgba(0,255,170,0.75)"],
              [94,18,"rgba(255,85,128,0.75)"],[114,45,"rgba(0,255,170,0.75)"],
              [134,10,"rgba(255,85,128,0.75)"],[154,60,"rgba(0,255,170,0.75)"],
              [174,35,"rgba(0,255,170,0.75)"],[194,48,"rgba(0,255,170,0.75)"],
              [214,22,"rgba(255,85,128,0.75)"],[234,55,"rgba(0,255,170,0.75)"],
            ].map(([x, h, c], i) => (
              <rect key={i} x={x - 7} y={80 - h} width={14} height={h} rx={3} fill={c} />
            ))}
            <path d="M14,65 L54,58 L94,72 L134,74 L174,52 L214,60 L234,42"
              fill="none" stroke="rgba(34,211,238,0.8)" strokeWidth="1.5" strokeDasharray="5 3" />
            <polygon points="234,42 227,38 227,46" fill="rgba(34,211,238,0.8)" />
          </svg>
        </div>
      </div>

      <div className="fp-chart-card fp-chart-full">
        <p className="fp-chart-title">Expected vs Realized Outcome</p>
        <p className="fp-chart-sub">Planned vs actual P&L — click any chart for a breakdown</p>
        <svg viewBox="0 0 480 70" width="100%" height="70" preserveAspectRatio="none">
          <defs>
            <linearGradient id="expGrad2" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="rgba(129,140,248,0.25)" />
              <stop offset="100%" stopColor="rgba(129,140,248,0)" />
            </linearGradient>
            <linearGradient id="realGrad2" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="rgba(34,211,238,0.25)" />
              <stop offset="100%" stopColor="rgba(34,211,238,0)" />
            </linearGradient>
          </defs>
          <path d="M0,55 L48,40 L96,48 L144,30 L192,38 L240,22 L288,28 L336,16 L384,20 L432,12 L480,8"
            fill="none" stroke="rgba(129,140,248,0.9)" strokeWidth="1.5" />
          <path d="M0,55 L48,40 L96,48 L144,30 L192,38 L240,22 L288,28 L336,16 L384,20 L432,12 L480,8 L480,70 L0,70Z"
            fill="url(#expGrad2)" />
          <path d="M0,58 L48,44 L96,36 L144,42 L192,28 L240,32 L288,18 L336,22 L384,14 L432,18 L480,4"
            fill="none" stroke="rgba(34,211,238,0.9)" strokeWidth="1.5" />
          <path d="M0,58 L48,44 L96,36 L144,42 L192,28 L240,32 L288,18 L336,22 L384,14 L432,18 L480,4 L480,70 L0,70Z"
            fill="url(#realGrad2)" />
        </svg>
        <div className="fp-chart-legend">
          <span className="fp-legend-item fp-legend-purple">● Expected P&L</span>
          <span className="fp-legend-item fp-legend-cyan">● Realized P&L</span>
        </div>
      </div>

      <div className="fp-insight-popup">
        <div className="fp-insight-header">
          <span className="fp-insight-icon green"><Ico d={I.trending} size={14} color="#00ffaa" sw={2} /></span>
          <span className="fp-insight-verdict green">Outperforming Expectations</span>
        </div>
        <div className="fp-insight-lines">
          <div className="fp-insight-line fp-insight-stat">
            <span className="fp-insight-num">01</span>
            <p>68% of trades beat planned P&L. Avg positive deviation: <strong style={{color:"#22d3ee"}}>+$142</strong>.</p>
          </div>
          <div className="fp-insight-line">
            <span className="fp-insight-num">02</span>
            <p>Your setups have more edge than your plan gives them credit for. Exit timing is improving naturally.</p>
          </div>
          <div className="fp-insight-line fp-insight-action">
            <span className="fp-insight-num">03</span>
            <p><Ico d={I.zap} size={12} color="#22d3ee" sw={2} style={{display:"inline",marginRight:6}} /> Raise take-profit targets by 15–20% on highest-conviction setups to capture more of this upside.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function PnlCalendarPreview() {
  const days = [
    null,null,{p:180,t:2,w:1},{p:-95,t:1,w:0},{p:320,t:3,w:2},{p:0,t:0},{p:0,t:0},
    {p:210,t:2,w:2},{p:175,t:2,w:1},{p:-140,t:1,w:0},{p:0,t:0},{p:440,t:3,w:3},{p:0,t:0},{p:0,t:0},
    {p:-60,t:1,w:0},{p:290,t:2,w:1},{p:380,t:2,w:2},{p:125,t:1,w:1},{p:-200,t:2,w:0},{p:0,t:0},{p:0,t:0},
    {p:0,t:0},{p:315,t:3,w:2},{p:260,t:2,w:2},{p:-80,t:1,w:0},{p:495,t:4,w:3},{p:0,t:0},{p:0,t:0},
    {p:180,t:2,w:1},{p:220,t:2,w:2},{p:null,t:0},{p:null,t:0},{p:null,t:0},{p:null,t:0},{p:null,t:0},
  ];

  const daysWithTrades = days.filter(d => d && d.t > 0);
  const winDays = daysWithTrades.filter(d => d.p > 0).length;
  const totalTrades = daysWithTrades.reduce((s, d) => s + d.t, 0);
  const totalWins   = daysWithTrades.reduce((s, d) => s + d.w, 0);

  return (
    <div className="fp-wrap">
      <div className="fp-dash-header">
        <div className="fp-eyebrow-row"><span className="fp-pip" /><span className="fp-eyebrow-text">MONTHLY RECAP</span></div>
        <div className="fp-title-row">
          <span className="fp-page-title">P&amp;L <em>Summary</em></span>
          <span className="fp-month-total green">June: +$2,840</span>
        </div>
      </div>

      <div className="fp-cal-stats" style={{gridTemplateColumns:"repeat(4,1fr)"}}>
        {[
          {l:"Total P&L",       v:"+$2,840",  c:"green"},
          {l:"Days Traded",     v:`${daysWithTrades.length} of 22`, c:""},
          {l:"Day Win Rate",    v:`${Math.round(winDays/daysWithTrades.length*100)}%`, c:"green"},
          {l:"Trade Win Rate",  v:`${Math.round(totalWins/totalTrades*100)}%`, c:"green"},
          {l:"Avg R:R",         v:"1:1.94",   c:""},
          {l:"Best Day",        v:"+$495",    c:"green"},
          {l:"Worst Day",       v:"-$200",    c:"red"},
        ].map(s => (
          <div className="fp-cal-stat-card" key={s.l}>
            <span className="fp-metric-label">{s.l}</span>
            <span className={`fp-metric-val ${s.c}`}>{s.v}</span>
          </div>
        ))}
      </div>

      <div className="fp-calendar-wrap">
        <div className="fp-cal-header-row">
          {["MON","TUE","WED","THU","FRI","SAT","SUN"].map(d => (
            <div key={d} className="fp-cal-weekday">{d}</div>
          ))}
          <div className="fp-cal-weekday fp-cal-weekday-total">WEEK</div>
        </div>
        {[0,1,2,3,4].map(week => {
          const slice = days.slice(week * 7, week * 7 + 7);
          const weekTotal = slice.filter(d => d && d.p !== null && d.t > 0).reduce((s, d) => s + d.p, 0);
          const hasData = slice.some(d => d && d.p !== null && d.t > 0);
          return (
            <div className="fp-cal-week-row" key={week}>
              {slice.map((d, i) => {
                if (!d) return <div key={i} className="fp-cal-day fp-cal-empty" />;
                if (d.p === null) return <div key={i} className="fp-cal-day fp-cal-future" />;
                if (d.t === 0) return <div key={i} className="fp-cal-day fp-cal-norade"><span className="fp-cal-dash">—</span></div>;
                return (
                  <div key={i} className={`fp-cal-day ${d.p > 0 ? "fp-cal-win" : d.p < 0 ? "fp-cal-loss" : "fp-cal-be"}`}>
                    <span className="fp-cal-pnl">{d.p > 0 ? "+" : ""}{d.p > 0 || d.p < 0 ? `$${Math.abs(d.p)}` : "BE"}</span>
                    <span className="fp-cal-trades">{d.t}t {d.w > 0 && <span className="fp-cal-wins-inline">{d.w}W</span>}</span>
                  </div>
                );
              })}
              <div className={`fp-cal-week-total ${!hasData ? "" : weekTotal > 0 ? "pos" : weekTotal < 0 ? "neg" : ""}`}>
                <span className="fp-cal-week-label">WK {week+1}</span>
                <span className="fp-cal-week-val">{hasData ? (weekTotal >= 0 ? "+" : "") + "$" + Math.abs(weekTotal) : "—"}</span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="fp-cal-legend">
        <span className="fp-cal-leg-item"><span className="fp-cal-leg-dot win" />Profit day</span>
        <span className="fp-cal-leg-item"><span className="fp-cal-leg-dot loss" />Loss day</span>
        <span className="fp-cal-leg-item" style={{fontFamily:"'DM Mono',monospace",fontSize:"10px",color:"#475569"}}>— No trades</span>
      </div>
    </div>
  );
}

function TradeHistoryPreview() {
  const trades = [
    {sym:"EURUSD",dir:"long", entry:"1.08420",exit:"1.09180",sl:"1.07900",tp:"1.09200",pnl:"+$320",eff:88,outcome:"TP Hit",cls:"tp",date:"02 Jun"},
    {sym:"XAUUSD",dir:"long", entry:"2318.40",exit:"2341.80",sl:"2305.00",tp:"2345.00",pnl:"+$495",eff:94,outcome:"TP Hit",cls:"tp",date:"11 Jun"},
    {sym:"GBPJPY",dir:"short",entry:"196.820",exit:"197.140",sl:"197.500",tp:"195.500",pnl:"-$140",eff:42,outcome:"SL Hit",cls:"sl",date:"05 Jun"},
    {sym:"NAS100",dir:"long", entry:"19420",  exit:"19605",  sl:"19310",  tp:"19650",  pnl:"+$180",eff:67,outcome:"Manual +",cls:"mp",date:"18 Jun"},
  ];
  const effClass = v => v>=70?"high":v>=40?"med":"low";
  return (
    <div className="fp-wrap">
      <div className="fp-dash-header">
        <div className="fp-eyebrow-row"><span className="fp-pip"/><span className="fp-eyebrow-text">JOURNAL</span></div>
        <div className="fp-title-row">
          <span className="fp-page-title">Trade <em>History</em></span>
          <span className="fp-live-badge"><span className="fp-live-dot"/>128 trades</span>
        </div>
      </div>

      <div className="fp-metrics-grid">
        {[{l:"Win Rate",v:"63.4%",c:"green"},{l:"Net P&L",v:"+$4,218",c:"green"},{l:"Profit Factor",v:"2.31",c:"green"},{l:"Avg R:R",v:"1:1.94",c:""}]
          .map(m=><div className="fp-metric-card" key={m.l}><span className="fp-metric-label">{m.l}</span><span className={`fp-metric-val ${m.c}`}>{m.v}</span></div>)}
      </div>

      <div style={{overflowX:"auto",borderRadius:12,border:"1px solid rgba(56,189,248,0.1)",marginBottom:10}}>
        <table style={{width:"100%",minWidth:580,borderCollapse:"separate",borderSpacing:0}}>
          <thead>
            <tr>{["Date","Symbol","Dir","Entry","Exit","SL","TP","Outcome","Eff %","P&L"].map(h=>
              <th key={h} style={{background:"rgba(13,21,32,0.98)",color:"#38bdf8",fontFamily:"'DM Mono',monospace",fontSize:9,letterSpacing:"0.12em",textTransform:"uppercase",padding:"8px 6px",borderBottom:"1px solid rgba(56,189,248,0.2)",textAlign:"center",whiteSpace:"nowrap"}}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {trades.map((t,i)=>(
              <tr key={i} style={{background:i%2===0?"rgba(5,15,30,0.3)":"transparent"}}>
                <td style={{color:"#64748b",fontFamily:"'DM Mono',monospace",fontSize:10,padding:"8px 6px",textAlign:"center",borderBottom:"1px solid rgba(56,189,248,0.05)"}}>{t.date}</td>
                <td style={{color:"#38bdf8",fontFamily:"'DM Mono',monospace",fontSize:11,fontWeight:700,padding:"8px 6px",textAlign:"center",borderBottom:"1px solid rgba(56,189,248,0.05)"}}>{t.sym}</td>
                <td style={{padding:"8px 6px",textAlign:"center",borderBottom:"1px solid rgba(56,189,248,0.05)"}}>
                  <span className={t.dir==="long"?"fp-dir-long":"fp-dir-short"} style={{fontSize:9}}>{t.dir==="long"?"▲ L":"▼ S"}</span>
                </td>
                {[t.entry,t.exit].map((v,j)=><td key={j} style={{color:"#94a3b8",fontFamily:"'DM Mono',monospace",fontSize:10,padding:"8px 6px",textAlign:"center",borderBottom:"1px solid rgba(56,189,248,0.05)"}}>{v}</td>)}
                <td style={{color:"#fca5a5",fontFamily:"'DM Mono',monospace",fontSize:10,padding:"8px 6px",textAlign:"center",borderBottom:"1px solid rgba(56,189,248,0.05)"}}>{t.sl}</td>
                <td style={{color:"#86efac",fontFamily:"'DM Mono',monospace",fontSize:10,padding:"8px 6px",textAlign:"center",borderBottom:"1px solid rgba(56,189,248,0.05)"}}>{t.tp}</td>
                <td style={{padding:"8px 6px",textAlign:"center",borderBottom:"1px solid rgba(56,189,248,0.05)"}}>
                  <span className={`fp-outcome-badge fp-outcome-${t.cls}`} style={{fontSize:8}}>{t.outcome}</span>
                </td>
                <td style={{padding:"8px 6px",textAlign:"center",borderBottom:"1px solid rgba(56,189,248,0.05)"}}>
                  <div style={{width:50,margin:"0 auto"}}>
                    <div style={{height:4,background:"rgba(30,41,59,0.8)",borderRadius:4,overflow:"hidden",marginBottom:2}}>
                      <div className={`fp-eff-fill ${effClass(t.eff)}`} style={{width:`${t.eff}%`,height:"100%",borderRadius:4}}/>
                    </div>
                    <span style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"#5a8fa0"}}>{t.eff}%</span>
                  </div>
                </td>
                <td style={{padding:"8px 6px",textAlign:"center",borderBottom:"1px solid rgba(56,189,248,0.05)"}}>
                  <span style={{fontFamily:"'DM Mono',monospace",fontSize:11,fontWeight:700,color:t.pnl.startsWith("+")?"#34d399":"#f87171"}}>{t.pnl}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="fp-insight-popup">
        <div className="fp-insight-header">
          <span className="fp-insight-icon green"><Ico d={I.trending} size={14} color="#00ffaa" sw={2}/></span>
          <span className="fp-insight-verdict green">Efficiency Score: execution quality beyond P&L</span>
        </div>
        <div className="fp-insight-lines">
          <div className="fp-insight-line fp-insight-stat">
            <span className="fp-insight-num">01</span>
            <p>Every trade gets an <strong style={{color:"#22d3ee"}}>efficiency score</strong> — RR achievement (70%), risk sizing (20%), psychology (10%).</p>
          </div>
          <div className="fp-insight-line fp-insight-action">
            <span className="fp-insight-num">02</span>
            <p><Ico d={I.zap} size={12} color="#22d3ee" sw={2} style={{display:"inline",marginRight:6}}/> A disciplined loss scores higher than an undisciplined win — because discipline compounds.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function TradeReviewPreview() {
  const [activeFilter, setActiveFilter] = useState("All");
  const [selectedTrade, setSelectedTrade] = useState(null);

  const trades = [
    {sym:"EURUSD", dir:"long",  eff:88, pnl:"+$320", pnlN:320,  outcome:"TP Hit",    cls:"tp", score:91, setup:"London BO",   date:"02 Jun 2025", emotion:"Calm",      session:"London", asset:"Forex"},
    {sym:"GBPJPY", dir:"short", eff:42, pnl:"-$140", pnlN:-140, outcome:"SL Hit",    cls:"sl", score:55, setup:"RSI Rev",     date:"05 Jun 2025", emotion:"Anxious",   session:"Asia",   asset:"Forex"},
    {sym:"XAUUSD", dir:"long",  eff:94, pnl:"+$495", pnlN:495,  outcome:"TP Hit",    cls:"tp", score:96, setup:"London BO",   date:"11 Jun 2025", emotion:"Calm",      session:"London", asset:"Commodities"},
    {sym:"NAS100", dir:"long",  eff:67, pnl:"+$180", pnlN:180,  outcome:"Manual +",  cls:"mp", score:78, setup:"VWAP Bounce", date:"18 Jun 2025", emotion:"Confident", session:"NY",     asset:"Index"},
    {sym:"GBPUSD", dir:"short", eff:55, pnl:"-$95",  pnlN:-95,  outcome:"SL Hit",    cls:"sl", score:48, setup:"RSI Rev",     date:"20 Jun 2025", emotion:"Anxious",   session:"London", asset:"Forex"},
    {sym:"BTCUSD", dir:"long",  eff:80, pnl:"+$260", pnlN:260,  outcome:"TP Hit",    cls:"tp", score:84, setup:"Breakout",    date:"24 Jun 2025", emotion:"Calm",      session:"NY",     asset:"Crypto"},
  ];

  const t = selectedTrade;

  return (
    <div className="fp-wrap" style={{position:"relative"}}>

      {t && (
        <div style={{position:"absolute",inset:0,background:"rgba(0,4,8,0.97)",zIndex:50,overflowY:"auto",overflowX:"hidden",padding:"12px",borderRadius:"inherit",display:"flex",flexDirection:"column",minHeight:"100%"}}>
          <button onClick={() => setSelectedTrade(null)}
            style={{background:"rgba(56,189,248,0.1)",border:"1px solid rgba(56,189,248,0.35)",color:"#38bdf8",padding:"7px 14px",borderRadius:"8px",cursor:"pointer",fontFamily:"'DM Mono',monospace",fontSize:"11px",letterSpacing:"0.1em",marginBottom:14,textTransform:"uppercase",display:"flex",alignItems:"center",gap:6,alignSelf:"flex-start",flexShrink:0,fontWeight:700}}>
            ← BACK
          </button>

          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8,paddingBottom:8,borderBottom:"1px solid rgba(56,189,248,0.08)"}}>
            <div>
              <div style={{fontFamily:"'Syne',sans-serif",fontSize:"1.4rem",fontWeight:900,color:"#dff0f8",letterSpacing:"-0.5px"}}>{t.sym}</div>
              <div style={{fontSize:9,color:"rgba(100,155,200,0.4)",fontFamily:"'DM Mono',monospace",letterSpacing:"0.1em",textTransform:"uppercase",marginTop:2}}>{t.setup} · {t.asset} · {t.date}</div>
            </div>
            <div className={`fp-trade-pnl ${t.pnlN > 0 ? "green" : "red"}`}
              style={{fontSize:"1.1rem",padding:"5px 12px",borderRadius:8,background:t.pnlN>0?"rgba(34,197,94,0.08)":"rgba(239,68,68,0.08)",border:`1px solid ${t.pnlN>0?"rgba(34,197,94,0.2)":"rgba(239,68,68,0.2)"}`}}>
              {t.pnl}
            </div>
          </div>

          <div style={{display:"grid",gridTemplateColumns:"minmax(0,1.5fr) minmax(0,1fr)",gap:8,marginBottom:8,minWidth:0,flex:1}}>
            <div style={{display:"flex",flexDirection:"column",gap:8,alignSelf:"start"}}>
              <div style={{background:"rgba(5,15,30,0.6)",border:"1px solid rgba(56,189,248,0.08)",borderRadius:10,padding:"10px 12px"}}>
                <div style={{fontSize:9,color:"rgba(56,189,248,0.65)",fontFamily:"'DM Mono',monospace",letterSpacing:"0.15em",textTransform:"uppercase",marginBottom:8,display:"flex",alignItems:"center",gap:5}}>
                  <span style={{display:"inline-block",width:2,height:10,background:"linear-gradient(180deg,#38bdf8,#818cf8)",borderRadius:2}} />
                  entry / exit
                </div>
                {[
                  ["direction", <span style={{color:t.dir==="long"?"#22c55e":"#ef4444"}}>{t.dir}</span>],
                  ["entry",     "1.08420"],
                  ["exit",      "1.09180"],
                  ["stop loss", "1.07900"],
                  ["take profit","1.09200"],
                  ["session",   t.session],
                ].map(([k, v]) => (
                  <div key={k} style={{display:"flex",justifyContent:"space-between",fontSize:"0.68rem",fontFamily:"'DM Mono',monospace",marginBottom:3}}>
                    <span style={{color:"#475569"}}>{k}</span>
                    <span style={{color:"#94a3b8"}}>{v}</span>
                  </div>
                ))}
              </div>

              <div style={{background:"rgba(5,15,30,0.6)",border:"1px solid rgba(56,189,248,0.08)",borderRadius:10,padding:"10px 12px"}}>
                <div style={{fontSize:9,color:"rgba(56,189,248,0.65)",fontFamily:"'DM Mono',monospace",letterSpacing:"0.15em",textTransform:"uppercase",marginBottom:8,display:"flex",alignItems:"center",gap:5}}>
                  <span style={{display:"inline-block",width:2,height:10,background:"linear-gradient(180deg,#38bdf8,#818cf8)",borderRadius:2}} />
                  trade info
                </div>
                {[
                  ["planned rr",  "1:2.0"],
                  ["realized rr", "1:1.94"],
                  ["outcome",     <span className={`fp-outcome-badge fp-outcome-${t.cls}`} style={{fontSize:9}}>{t.outcome}</span>],
                  ["emotion",     t.emotion],
                  ["rules",       <span style={{color:"#22c55e",fontSize:9}}>✓ followed</span>],
                ].map(([k, v]) => (
                  <div key={k} style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:"0.68rem",fontFamily:"'DM Mono',monospace",marginBottom:3}}>
                    <span style={{color:"#475569"}}>{k}</span>
                    <span style={{color:"#94a3b8"}}>{v}</span>
                  </div>
                ))}
              </div>

              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,alignContent:"start"}}>
                {[
                  {label:"Efficiency",   val:t.eff,   color:"#fbbf24", desc:"rr·risk·psych"},
                  {label:"TrackR Score", val:t.score, color:"#38bdf8", desc:"win·efficiency"},
                ].map(sc => (
                  <div key={sc.label} style={{background:"rgba(5,15,30,0.6)",border:`1px solid ${sc.color}22`,borderRadius:10,padding:"8px 10px",height:"fit-content"}}>
                    <div style={{fontSize:8,color:"rgba(100,155,200,0.4)",fontFamily:"'DM Mono',monospace",letterSpacing:"0.12em",textTransform:"uppercase",marginBottom:3}}>{sc.label}</div>
                    <div style={{fontFamily:"'Syne',sans-serif",fontSize:"1.3rem",fontWeight:900,color:sc.color,lineHeight:1,marginBottom:5}}>{sc.val}</div>
                    <div style={{height:3,background:"rgba(255,255,255,0.06)",borderRadius:99,overflow:"hidden",marginBottom:3}}>
                      <div style={{width:`${sc.val}%`,height:"100%",background:sc.color,borderRadius:99}} />
                    </div>
                    <div style={{fontSize:7,color:"#334155",fontFamily:"'DM Mono',monospace"}}>{sc.desc}</div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{background:"rgba(5,15,30,0.6)",border:"1px solid rgba(56,189,248,0.08)",borderRadius:10,padding:"10px 12px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
              <div style={{fontSize:9,color:"rgba(56,189,248,0.65)",fontFamily:"'DM Mono',monospace",letterSpacing:"0.15em",textTransform:"uppercase",marginBottom:4,alignSelf:"flex-start",display:"flex",alignItems:"center",gap:5}}>
                <span style={{display:"inline-block",width:2,height:10,background:"linear-gradient(180deg,#38bdf8,#818cf8)",borderRadius:2}} />
                behavior radar
              </div>
              <RadarMini
                values={[100, t.pnlN > 0 ? 100 : 30, t.eff, 100, 90]}
                labels={["Rules","Outcome","Exec","Emotion","Prep"]}
                color="#38bdf8"
              />
            </div>
          </div>
        </div>
      )}

      <div className="fp-dash-header">
        <div className="fp-eyebrow-row"><span className="fp-pip" /><span className="fp-eyebrow-text">ANALYTICS</span></div>
        <div className="fp-title-row">
          <span className="fp-page-title">Trade <em>Review</em></span>
        </div>
      </div>

      <div className="fp-review-filter-bar" style={{marginBottom:6}}>
        {["All Assets","Forex","Crypto","Stocks","Index","Commodities"].map(a => (
          <button key={a} className={`fp-filter-btn ${a==="All Assets" ? "active" : ""}`}>{a}</button>
        ))}
      </div>

      <div className="fp-review-filter-bar">
        {["All","Wins","Losses","Break Even","Strategy","Emotion","Session"].map(f => (
          <button key={f} className={`fp-filter-btn ${activeFilter===f ? "active" : ""}`} onClick={() => setActiveFilter(f)}>{f}</button>
        ))}
      </div>

      <div className="fp-tr-stats-panel">
        <div className="fp-tr-stats-heading">
          <span className="fp-tr-stats-bar" />
          performance summary
          <span style={{fontSize:9,color:"rgba(100,155,200,0.35)",fontFamily:"'DM Mono',monospace"}}>all assets · all trades</span>
        </div>
        <div className="fp-metrics-grid" style={{gridTemplateColumns:"repeat(4,1fr)",marginBottom:10}}>
          {[
            {l:"Trades",       v:"142",     c:""},
            {l:"Total P&L",    v:"+$4,218", c:"green"},
            {l:"Avg P&L",      v:"+$29.70", c:"green"},
            {l:"Win Rate",     v:"63.4%",   c:"green"},
            {l:"Loss Rate",    v:"31.0%",   c:"red"},
            {l:"Break Even",   v:"5.6%",    c:""},
            {l:"Avg Eff",      v:"71%",     c:""},
            {l:"Biggest Win",  v:"+$892",   c:"green"},
            {l:"Biggest Loss", v:"-$340",   c:"red"},
            {l:"Planned RR",   v:"1:2.0",   c:""},
            {l:"Realized RR",  v:"1:1.94",  c:""},
          ].map(s => (
            <div className="fp-metric-card" key={s.l}>
              <span className="fp-metric-label">{s.l}</span>
              <span className={`fp-metric-val ${s.c}`} style={{fontSize:"0.9rem"}}>{s.v}</span>
            </div>
          ))}
        </div>
        <div className="fp-tr-best-section">
          <div className="fp-tr-best-heading"><span className="fp-tr-trophy-bar" />best &amp; worst</div>
          <div className="fp-tr-best-grid">
            {[
              {l:"best symbol",    v:"XAUUSD",    c:"green"},
              {l:"worst symbol",   v:"GBPJPY",    c:"red"},
              {l:"best strategy",  v:"London BO", c:"green"},
              {l:"worst strategy", v:"RSI Rev",   c:"red"},
              {l:"best emotion",   v:"Calm",      c:"green"},
              {l:"best session",   v:"London",    c:"green"},
            ].map(b => (
              <div className="fp-tr-best-item" key={b.l}>
                <span className="fp-tr-best-label">{b.l}</span>
                <span className={`fp-tr-best-val ${b.c}`}>{b.v}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:10}}>
        {[
          {title:"win rate by strategy", segs:[
            {pct:71, color:"rgba(52,211,153,0.9)",  label:"71%"},
            {pct:23, color:"rgba(248,113,113,0.9)", label:""},
            {pct:6,  color:"rgba(251,191,36,0.9)",  label:""},
          ], keys:["London BO 71%","RSI Rev 23%","Other 6%"]},
          {title:"win rate by emotion", segs:[
            {pct:74, color:"rgba(34,211,238,0.9)",  label:"74%"},
            {pct:20, color:"rgba(248,113,113,0.9)", label:""},
            {pct:6,  color:"rgba(129,140,248,0.9)", label:""},
          ], keys:["Calm 74%","Anxious 20%","Confident 6%"]},
          {title:"win rate by session", segs:[
            {pct:68, color:"rgba(129,140,248,0.9)", label:"68%"},
            {pct:22, color:"rgba(52,211,153,0.9)",  label:""},
            {pct:10, color:"rgba(251,191,36,0.9)",  label:""},
          ], keys:["London 68%","NY 22%","Asia 10%"]},
        ].map(chart => (
          <div key={chart.title} className="fp-chart-card" style={{display:"flex",flexDirection:"column",alignItems:"center",padding:"10px 8px"}}>
            <p className="fp-chart-title" style={{fontSize:10,marginBottom:6,alignSelf:"flex-start"}}>{chart.title}</p>
            <MiniDonut segments={chart.segs} size={54} />
            <div style={{marginTop:6,width:"100%"}}>
              {chart.keys.map((l, i) => (
                <div key={i} style={{display:"flex",alignItems:"center",gap:4,fontSize:8,color:"#64748b",fontFamily:"'DM Mono',monospace",marginBottom:2}}>
                  <span style={{width:6,height:6,borderRadius:2,background:chart.segs[i].color,flexShrink:0,display:"inline-block"}} />
                  {l}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="fp-insight-popup" style={{marginBottom:10}}>
        <div className="fp-insight-header">
          <span className="fp-insight-icon red"><Ico d={I.brain} size={13} color="#ef4444" sw={1.5} /></span>
          <span className="fp-insight-verdict red">Psychology Pattern Detected</span>
        </div>
        <div className="fp-insight-lines">
          <div className="fp-insight-line fp-insight-stat">
            <span className="fp-insight-num">01</span>
            <p>Anxious trades: <strong style={{color:"#ef4444"}}>24% win rate</strong> vs <strong style={{color:"#00ffaa"}}>71% when calm</strong>. Across 38 trades.</p>
          </div>
          <div className="fp-insight-line fp-insight-action">
            <span className="fp-insight-num">02</span>
            <p>Only take entries when calm or confident. Emotion is the single most controllable variable in your edge.</p>
          </div>
        </div>
      </div>

      <div style={{fontSize:9,color:"rgba(100,155,200,0.35)",fontFamily:"'DM Mono',monospace",letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:6,display:"flex",alignItems:"center",gap:6}}>
        <span style={{display:"inline-block",width:3,height:14,background:"linear-gradient(180deg,#38bdf8,#818cf8)",borderRadius:2}} />
        trade list <span style={{color:"#475569"}}>({trades.length})</span>
        <span style={{marginLeft:4,color:"rgba(56,189,248,0.4)"}}>· click any card</span>
      </div>

      <div className="fp-tr-cards-grid">
        {trades.map((tr, i) => (
          <div className="fp-tr-card" key={i} onClick={() => setSelectedTrade(tr)}>
            <div className="fp-tr-card-header">
              <span className="fp-trade-sym" style={{gap:5}}>
                {tr.sym}
                <span className={tr.dir==="long" ? "fp-dir-long" : "fp-dir-short"} style={{fontSize:9}}>
                  {tr.dir==="long" ? "▲ LONG" : "▼ SHORT"}
                </span>
              </span>
              <span className={`fp-trade-pnl ${tr.pnlN > 0 ? "green" : "red"}`} style={{fontSize:12}}>{tr.pnl}</span>
            </div>
            <div style={{fontSize:9,color:"rgba(100,155,200,0.4)",fontFamily:"'DM Mono',monospace",marginBottom:6,lineHeight:1.7}}>
              <span style={{color:"#475569"}}>setup</span> {tr.setup} &nbsp;·&nbsp; <span style={{color:"#475569"}}>asset</span> {tr.asset}
            </div>
            <div className="fp-eff-bar-wrap" style={{marginBottom:6}}>
              <span className="fp-eff-label">Eff {tr.eff}%</span>
              <div className="fp-eff-track">
                <div className={`fp-eff-fill ${tr.eff>=70?"high":tr.eff>=40?"med":"low"}`} style={{width:`${tr.eff}%`}} />
              </div>
            </div>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",paddingTop:7,borderTop:"1px solid rgba(56,189,248,0.06)"}}>
              <span style={{fontSize:8,color:"rgba(100,155,200,0.25)",fontFamily:"'DM Mono',monospace",letterSpacing:"0.1em",textTransform:"uppercase"}}>{tr.date}</span>
              <div style={{display:"flex",alignItems:"center",gap:5}}>
                <span className={`fp-outcome-badge fp-outcome-${tr.cls}`} style={{fontSize:8,padding:"1px 5px"}}>{tr.outcome}</span>
                <span className="fp-score-chip" style={{fontSize:10}}>{tr.score}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function EquityCurvePreview() {
  const [startMode, setStartMode] = useState("zero");
  const [timeFilter, setTimeFilter] = useState("all");

  const equityPoints = [
    {x:0,y:88},{x:30,y:84},{x:60,y:78},{x:90,y:74},{x:120,y:76},
    {x:150,y:68},{x:180,y:58},{x:210,y:62},{x:240,y:50},{x:270,y:42},
    {x:300,y:38},{x:330,y:44},{x:360,y:32},{x:390,y:24},{x:420,y:18},{x:450,y:14},{x:480,y:8}
  ];
  const linePath = equityPoints.map((p,i) => `${i===0?"M":"L"}${p.x},${p.y}`).join(" ");
  const fillPath = linePath + " L480,100 L0,100 Z";

  return (
    <div className="fp-wrap">
      {/* Header — matches real pg-header */}
      <div style={{textAlign:"center",marginBottom:14,borderBottom:"1px solid rgba(56,189,248,0.08)",paddingBottom:12}}>
        <div style={{fontFamily:"'Syne',sans-serif",fontSize:"clamp(16px,3vw,22px)",fontWeight:900,letterSpacing:"0.03em",color:"#e2e8f0",marginBottom:4}}>
          PERFORMANCE<span style={{background:"linear-gradient(135deg,#38bdf8,#818cf8,#ec4899)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",backgroundClip:"text"}}>_GRAPH</span>
        </div>
        <div style={{width:60,height:2,background:"linear-gradient(90deg,transparent,#38bdf8,#818cf8,transparent)",margin:"4px auto 6px"}} />
        <div style={{fontSize:9,color:"#334155",letterSpacing:"0.25em",fontFamily:"'DM Mono',monospace",textTransform:"uppercase"}}>Real-Time Trading Analytics</div>
        {/* MT5 indicator pill */}
        <div style={{display:"inline-flex",alignItems:"center",gap:5,marginTop:6,background:"rgba(167,139,250,0.08)",border:"1px solid rgba(167,139,250,0.2)",borderRadius:100,padding:"2px 10px"}}>
          <svg width="8" height="8" viewBox="0 0 24 24" fill="#a78bfa"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
          <span style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"#a78bfa",letterSpacing:"0.08em"}}>14 MT5 synced trades included</span>
        </div>
      </div>

      {/* KPI Row — matches real pg-kpi-row */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:6,marginBottom:8}}>
        {[
          {label:"TOTAL TRADES", val:"142", sub:"14 mt5 · 128 manual", color:"#38bdf8"},
          {label:"FINAL BALANCE", val:"$14,218", color:"#22c55e"},
          {label:"TOTAL P&L", val:"+$4,218", color:"#22c55e"},
          {label:"WIN RATE", val:"63.4%", color:"#e2e8f0"},
        ].map(k => (
          <div key={k.label} style={{background:"rgba(15,23,42,0.65)",border:"1px solid rgba(56,189,248,0.12)",borderRadius:10,padding:"10px 8px",display:"flex",flexDirection:"column",alignItems:"center",gap:3,position:"relative",overflow:"hidden"}}>
            <div style={{position:"absolute",top:0,left:0,right:0,height:1,background:"linear-gradient(90deg,transparent,rgba(56,189,248,0.5),transparent)"}} />
            <span style={{fontFamily:"'DM Mono',monospace",fontSize:8,color:"#38bdf8",letterSpacing:"0.12em",fontWeight:700,textTransform:"uppercase",textAlign:"center"}}>{k.label}</span>
            <span style={{fontFamily:"'Syne',sans-serif",fontSize:"clamp(0.9rem,2.5vw,1.4rem)",fontWeight:800,color:k.color,lineHeight:1,textAlign:"center",width:"100%",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{k.val}</span>
            {k.sub && <span style={{fontFamily:"'DM Mono',monospace",fontSize:7,color:"#475569",textAlign:"center"}}>{k.sub}</span>}
          </div>
        ))}
      </div>

      {/* Period stats row — matches real pg-period-row */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6,marginBottom:8}}>
        {[
          {label:"AVG R:R", val:"1.94", bg:"rgba(56,189,248,0.08)", border:"rgba(56,189,248,0.2)", col:"#38bdf8"},
          {label:"AVG P&L / TRADE", val:"+$29.70", bg:"rgba(34,197,94,0.08)", border:"rgba(34,197,94,0.2)", col:"#4ade80"},
          {label:"BEST ASSET", val:"XAUUSD", bg:"rgba(129,140,248,0.08)", border:"rgba(129,140,248,0.2)", col:"#818cf8"},
        ].map(p => (
          <div key={p.label} style={{background:p.bg,border:`1px solid ${p.border}`,borderRadius:8,padding:"8px",display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
            <span style={{fontFamily:"'DM Mono',monospace",fontSize:8,color:p.col,letterSpacing:"0.1em",fontWeight:700,textTransform:"uppercase",textAlign:"center"}}>{p.label}</span>
            <span style={{fontFamily:"'Syne',sans-serif",fontSize:"0.95rem",fontWeight:700,color:"#e2e8f0",textAlign:"center"}}>{p.val}</span>
          </div>
        ))}
      </div>

      {/* All-time bests — matches real pg-alltime-row */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6,marginBottom:10}}>
        {[
          {label:"BEST PAIR", val:"XAUUSD"},
          {label:"BEST MONTH", val:"Mar 2025"},
          {label:"BEST YEAR", val:"2025"},
        ].map(b => (
          <div key={b.label} style={{background:"rgba(5,15,30,0.55)",border:"1px solid rgba(56,189,248,0.1)",borderRadius:10,padding:"8px 10px",display:"flex",alignItems:"center",gap:6,minWidth:0,overflow:"hidden",position:"relative"}}>
            <div style={{position:"absolute",bottom:0,left:0,right:0,height:1,background:"linear-gradient(90deg,transparent,rgba(56,189,248,0.2),transparent)"}} />
            <div style={{display:"flex",flexDirection:"column",gap:2,flex:1,minWidth:0}}>
              <span style={{fontFamily:"'DM Mono',monospace",fontSize:7,color:"#475569",letterSpacing:"0.1em",fontWeight:700,textTransform:"uppercase"}}>{b.label}</span>
              <span style={{fontFamily:"'Syne',sans-serif",fontSize:"0.85rem",fontWeight:700,color:"#e2e8f0",textTransform:"uppercase",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{b.val}</span>
            </div>
            <span style={{fontFamily:"'DM Mono',monospace",fontSize:6,color:"#38bdf8",background:"rgba(56,189,248,0.1)",border:"1px solid rgba(56,189,248,0.2)",borderRadius:3,padding:"2px 4px",whiteSpace:"nowrap",flexShrink:0,letterSpacing:"0.1em"}}>ALL TIME</span>
          </div>
        ))}
      </div>

      {/* Filters — matches real pg-filters */}
      <div style={{display:"flex",gap:8,marginBottom:10,flexWrap:"wrap"}}>
        {[
          {label:"BASELINE", opts:["Start from $0","Initial Balance ($10,000)"], val:startMode, onChange:setStartMode, keys:["zero","balance"]},
          {label:"TIME RANGE", opts:["All Time","By Year","By Month"], val:timeFilter, onChange:setTimeFilter, keys:["all","year","month"]},
        ].map(f => (
          <div key={f.label} style={{display:"flex",flexDirection:"column",gap:4,flex:1,minWidth:120}}>
            <span style={{fontFamily:"'DM Mono',monospace",fontSize:8,color:"#38bdf8",letterSpacing:"0.15em",fontWeight:700,textTransform:"uppercase"}}>{f.label}</span>
            <select
              value={f.val}
              onChange={e => f.onChange(e.target.value)}
              style={{padding:"6px 8px",background:"rgba(15,23,42,0.7)",border:"1px solid rgba(56,189,248,0.2)",borderRadius:8,color:"#cbd5e1",fontSize:"0.75rem",cursor:"pointer",fontFamily:"'DM Mono',monospace"}}
            >
              {f.opts.map((o,i) => <option key={i} value={f.keys[i]}>{o}</option>)}
            </select>
          </div>
        ))}
      </div>

      {/* Graph box — matches real pg-graph-box */}
      <div style={{background:"rgba(10,18,35,0.65)",border:"1px solid rgba(56,189,248,0.12)",borderRadius:14,overflow:"hidden",boxShadow:"0 24px 60px rgba(0,0,0,0.5)"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 14px",borderBottom:"1px solid rgba(56,189,248,0.08)"}}>
          <span style={{fontFamily:"'DM Mono',monospace",fontSize:9,letterSpacing:"0.2em",color:"#334155",fontWeight:700,textTransform:"uppercase"}}>EQUITY CURVE</span>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <div style={{display:"inline-flex",alignItems:"center",gap:5,background:"rgba(167,139,250,0.08)",border:"1px solid rgba(167,139,250,0.2)",borderRadius:100,padding:"2px 8px"}}>
              <svg width="7" height="7" viewBox="0 0 24 24" fill="#a78bfa"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
              <span style={{fontFamily:"'DM Mono',monospace",fontSize:8,color:"#a78bfa"}}>14 MT5 synced</span>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:5,fontFamily:"'DM Mono',monospace",fontSize:9,fontWeight:700,color:"#22c55e",letterSpacing:"0.15em",textTransform:"uppercase"}}>
              <span style={{width:7,height:7,borderRadius:"50%",background:"#22c55e",display:"inline-block",animation:"livePulse 2s ease infinite"}} />
              NET POSITIVE
            </div>
          </div>
        </div>
        <div style={{padding:"12px 12px 16px",position:"relative"}}>
          {/* Y-axis labels */}
          <div style={{position:"absolute",left:4,top:12,bottom:16,display:"flex",flexDirection:"column",justifyContent:"space-between",pointerEvents:"none"}}>
            {["$14.2k","$12k","$10k","$8k","$0"].map(l => (
              <span key={l} style={{fontFamily:"'DM Mono',monospace",fontSize:7,color:"#475569"}}>{l}</span>
            ))}
          </div>
          <svg viewBox="0 0 480 110" width="100%" height="110" preserveAspectRatio="none" style={{marginLeft:24}}>
            <defs>
              <linearGradient id="eqFullG2" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="rgba(34,197,94,0.35)" />
                <stop offset="95%" stopColor="rgba(34,197,94,0.02)" />
              </linearGradient>
            </defs>
            {/* Grid lines */}
            {[22,44,66,88].map(y => (
              <line key={y} x1="0" y1={y} x2="480" y2={y} stroke="rgba(56,189,248,0.07)" strokeDasharray="3 3" strokeWidth="1"/>
            ))}
            {/* Zero reference */}
            <line x1="0" y1="88" x2="480" y2="88" stroke="rgba(56,189,248,0.35)" strokeDasharray="6 4" strokeWidth="1.5"/>
            <text x="390" y="85" fill="rgba(56,189,248,0.5)" fontSize="7" fontFamily="monospace">ZERO</text>
            {/* Equity curve */}
            <path d={fillPath} fill="url(#eqFullG2)" />
            <path d={linePath} fill="none" stroke="#22c55e" strokeWidth="2.5" />
            {/* Milestone dots */}
            {[[150,68],[300,38],[480,8]].map(([x,y],i) => (
              <g key={i}>
                <circle cx={x} cy={y} r={5} fill="rgba(34,197,94,0.2)" />
                <circle cx={x} cy={y} r={3} fill="#22c55e" />
              </g>
            ))}
            {/* X-axis labels */}
            {[["Jan",0],["Mar",96],["May",192],["Jul",288],["Sep",384],["Nov",480]].map(([m,x]) => (
              <text key={m} x={x} y={108} fill="#475569" fontSize="7" fontFamily="monospace" textAnchor="middle">{m}</text>
            ))}
          </svg>
        </div>
      </div>
    </div>
  );
}

function MT5Preview() {
  const [phase, setPhase] = useState(0);
  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 500);
    const t2 = setTimeout(() => setPhase(2), 2000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);
  return (
    <div className="fp-wrap">
      <div className="fp-dash-header">
        <div className="fp-eyebrow-row"><span className="fp-pip" /><span className="fp-eyebrow-text">MT5 AUTO-SYNC</span></div>
        <div className="fp-title-row">
          <span className="fp-page-title">Zero Manual <em>Entry</em></span>
          {phase === 2 && <span className="fp-live-badge"><span className="fp-live-dot" />LIVE</span>}
        </div>
      </div>

      <div className="fp-mt5-connection">
        <div className="fp-mt5-box">
          <Ico d={I.chart} size={18} color="#a78bfa" sw={1.5} />
          <div>
            <p className="fp-mt5-box-title">MetaTrader 5</p>
            <p className="fp-mt5-box-sub">Account #12847291</p>
          </div>
        </div>
        <div className={`fp-mt5-arrow ${phase===1?"syncing":phase===2?"done":""}`}>
          <div className="fp-mt5-arrow-line" />
          <span className="fp-mt5-arrow-label">{phase===0?"Ready":phase===1?"Syncing...":"Auto-sync"}</span>
          <div className="fp-mt5-arrow-line" />
        </div>
        <div className="fp-mt5-box">
          <Ico d={I.journal} size={18} color="#22d3ee" sw={1.5} />
          <div>
            <p className="fp-mt5-box-title">TrackR Journal</p>
            <p className="fp-mt5-box-sub">{phase===2?"14 trades imported":"Waiting..."}</p>
          </div>
        </div>
      </div>

      <div className="fp-mt5-trades-list">
        {[
          {sym:"EURUSD",lot:0.5,pnl:"+$214",time:"09:32",dir:"BUY"},
          {sym:"XAUUSD",lot:0.1,pnl:"-$87", time:"11:15",dir:"SELL"},
          {sym:"GBPUSD",lot:0.3,pnl:"+$156",time:"14:02",dir:"BUY"},
          {sym:"NAS100",lot:0.2,pnl:"+$380",time:"15:44",dir:"BUY"},
        ].map((t, i) => (
          <div className={`fp-mt5-trade-row ${phase===2?"visible":""}`} key={i} style={{transitionDelay:`${i*0.12}s`}}>
            <span className="fp-mt5-badge-icon"><Ico d={I.zap} size={10} color="#a78bfa" sw={2} /></span>
            <span className="fp-trade-sym" style={{fontSize:13}}>{t.sym}</span>
            <span className={`fp-dir-${t.dir==="BUY"?"long":"short"}`} style={{fontSize:10}}>{t.dir}</span>
            <span className="fp-mt5-lot">{t.lot} lot</span>
            <span className="fp-mt5-time">{t.time}</span>
            <span className={`fp-trade-pnl ${t.pnl.startsWith("+")?"green":"red"}`}>{t.pnl}</span>
            <span className="fp-mt5-auto-label">AUTO</span>
          </div>
        ))}
      </div>
      <p className="fp-mt5-note">Connect once — every trade syncs automatically. No manual entry ever.</p>
    </div>
  );
}

function ScoresPreview() {
  const trackRScores = [74,85,60,55,70,65];
  const mequScores  = [80,55,72,60,75];
  const trLabels = ["Win Rate","Profit Factor","R:R Ratio","Expectancy","Total P&L","Win Days"];
  const meLabels = ["Preparedness","Discipline","Confidence","Rules","Execution"];
  return (
    <div className="fp-wrap">
      <div className="fp-dash-header">
        <div className="fp-eyebrow-row"><span className="fp-pip" /><span className="fp-eyebrow-text">PERFORMANCE SCORES</span></div>
        <div className="fp-title-row">
          <span className="fp-page-title">TrackR & <em>MEQU</em></span>
        </div>
      </div>

      <div className="fp-scores-grid">
        <div className="fp-score-panel fp-score-cyan">
          <div className="fp-score-top">
            <div>
              <p className="fp-score-name">TrackR Score</p>
              <p className="fp-score-desc-small">Outcome-based performance</p>
            </div>
            <div className="fp-score-number-box">
              <p className="fp-score-big cyan">74</p>
              <p className="fp-score-denom">/100</p>
            </div>
          </div>
          <div className="fp-score-radar-mock">
            <svg viewBox="-60 -60 120 120" width="130" height="130">
              {[0.33,0.66,1].map((r,ri) => (
                <polygon key={ri}
                  points={[0,1,2,3,4,5].map(i => {
                    const a = (i*60-90)*Math.PI/180;
                    return `${Math.cos(a)*50*r},${Math.sin(a)*50*r}`;
                  }).join(" ")}
                  fill="none" stroke="rgba(34,211,238,0.1)" strokeWidth={1} />
              ))}
              {[0,1,2,3,4,5].map(i => {
                const a = (i*60-90)*Math.PI/180;
                return <line key={i} x1={0} y1={0} x2={Math.cos(a)*50} y2={Math.sin(a)*50} stroke="rgba(34,211,238,0.1)" strokeWidth={1} />;
              })}
              <polygon
                points={trackRScores.map((v,i) => {
                  const a = (i*60-90)*Math.PI/180;
                  const r = (v/100)*48;
                  return `${Math.cos(a)*r},${Math.sin(a)*r}`;
                }).join(" ")}
                fill="rgba(34,211,238,0.18)" stroke="rgba(34,211,238,0.8)" strokeWidth="1.5" />
            </svg>
          </div>
          <div className="fp-score-bars">
            {trLabels.map((l,i) => (
              <div className="fp-score-bar-row" key={l}>
                <span className="fp-score-bar-label">{l}</span>
                <div className="fp-score-bar-track">
                  <div className="fp-score-bar-fill" style={{width:`${trackRScores[i]}%`,background:"rgba(34,211,238,0.7)"}} />
                </div>
                <span className="fp-score-bar-val">{trackRScores[i]}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="fp-score-panel fp-score-violet">
          <div className="fp-score-top">
            <div>
              <p className="fp-score-name">MEQU Score</p>
              <p className="fp-score-desc-small">Psychology-based performance</p>
            </div>
            <div className="fp-score-number-box" style={{borderColor:"rgba(167,139,250,0.3)"}}>
              <p className="fp-score-big violet">68</p>
              <p className="fp-score-denom">/100</p>
            </div>
          </div>
          <div className="fp-score-radar-mock">
            <svg viewBox="-60 -60 120 120" width="130" height="130">
              {[0.33,0.66,1].map((r,ri) => (
                <polygon key={ri}
                  points={[0,1,2,3,4].map(i => {
                    const a = (i*72-90)*Math.PI/180;
                    return `${Math.cos(a)*50*r},${Math.sin(a)*50*r}`;
                  }).join(" ")}
                  fill="none" stroke="rgba(167,139,250,0.1)" strokeWidth={1} />
              ))}
              {[0,1,2,3,4].map(i => {
                const a = (i*72-90)*Math.PI/180;
                return <line key={i} x1={0} y1={0} x2={Math.cos(a)*50} y2={Math.sin(a)*50} stroke="rgba(167,139,250,0.1)" strokeWidth={1} />;
              })}
              <polygon
                points={mequScores.map((v,i) => {
                  const a = (i*72-90)*Math.PI/180;
                  const r = (v/100)*48;
                  return `${Math.cos(a)*r},${Math.sin(a)*r}`;
                }).join(" ")}
                fill="rgba(167,139,250,0.18)" stroke="rgba(167,139,250,0.8)" strokeWidth="1.5" />
            </svg>
          </div>
          <div className="fp-score-bars">
            {meLabels.map((l,i) => (
              <div className="fp-score-bar-row" key={l}>
                <span className="fp-score-bar-label">{l}</span>
                <div className="fp-score-bar-track">
                  <div className="fp-score-bar-fill" style={{width:`${mequScores[i]}%`,background:"rgba(167,139,250,0.7)"}} />
                </div>
                <span className="fp-score-bar-val">{mequScores[i]}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="fp-insight-popup" style={{marginTop:8}}>
        <div className="fp-insight-header">
          <span className="fp-insight-icon" style={{color:"#facc15"}}><Ico d={I.brain} size={13} color="#facc15" sw={1.5} /></span>
          <span className="fp-insight-verdict" style={{color:"#facc15"}}>Process Needs Refinement</span>
        </div>
        <div className="fp-insight-lines">
          <div className="fp-insight-line fp-insight-action">
            <span className="fp-insight-num">01</span>
            <p><Ico d={I.zap} size={12} color="#22d3ee" sw={2} style={{display:"inline",marginRight:6}} /> A 10-point improvement in <strong style={{color:"#a78bfa"}}>Discipline</strong> typically translates to a measurable win rate increase within 30 trades.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function PlaybookPreview() {
  return (
    <div className="fp-wrap">
      <div className="fp-dash-header">
        <div className="fp-eyebrow-row"><span className="fp-pip" /><span className="fp-eyebrow-text">PLAYBOOK + CHECKLISTS</span></div>
        <div className="fp-title-row">
          <span className="fp-page-title">Document Your <em>Edge</em></span>
        </div>
      </div>

      <div className="fp-playbook-card">
        <div className="fp-pb-header">
          <Ico d={I.book} size={16} color="#22d3ee" sw={1.5} />
          <span className="fp-pb-setup-name">London Breakout</span>
          <span className="fp-pb-win-badge">Win Rate: 71%</span>
        </div>
        <div className="fp-pb-rules">
          {[
            {ok:true, text:"Price consolidates 30min before London open"},
            {ok:true, text:"Break + retest of range high/low confirmed"},
            {ok:true, text:"Minimum 1:2 R:R before entry"},
            {ok:false,text:"Avoid if major news within 1hr"},
            {ok:false,text:"Never trade without defined stop loss"},
          ].map((r,i) => (
            <div className="fp-pb-rule" key={i}>
              <Ico d={r.ok?I.check:I.close} size={11} color={r.ok?"#34d399":"#ef4444"} sw={2.5} />
              <span style={{color:r.ok?"#94a3b8":"#64748b"}}>{r.text}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="fp-checklist-card">
        <div className="fp-cl-header">
          <Ico d={I.checklist} size={14} color="#818cf8" sw={1.5} />
          <span className="fp-cl-title">Pre-Trade Gate</span>
          <span className="fp-discipline-meter">
            <span className="fp-discipline-label">Discipline</span>
            <div className="fp-discipline-track"><div className="fp-discipline-fill" style={{width:"85%"}} /></div>
            <span className="fp-discipline-pct">85%</span>
          </span>
        </div>
        {[
          {done:true, text:"Checked economic calendar — no major news"},
          {done:true, text:"Setup matches London Breakout playbook rules"},
          {done:true, text:"Risk calculated at 1% — SL at range low"},
          {done:true, text:"Account preparedness score above 75%"},
          {done:false,text:"Emotional state: Calm/Confident confirmed"},
        ].map((item,i) => (
          <div className="fp-cl-item" key={i} style={{background:item.done?"rgba(74,222,128,0.05)":"rgba(255,255,255,0.02)",borderColor:item.done?"rgba(74,222,128,0.2)":"rgba(56,189,248,0.1)"}}>
            <div className={`fp-cl-box ${item.done?"checked":""}`}>
              {item.done && <Ico d={I.check} size={10} color="#4ade80" sw={2.5} />}
            </div>
            <span style={{color:item.done?"rgba(255,255,255,0.45)":"rgba(255,255,255,0.85)",textDecoration:item.done?"line-through":"none",fontSize:12}}>{item.text}</span>
          </div>
        ))}
      </div>

      <div className="fp-insight-popup" style={{marginTop:8}}>
        <div className="fp-insight-lines">
          <div className="fp-insight-line fp-insight-action">
            <span className="fp-insight-num">TIP</span>
            <p>Rules that gate every entry push Discipline above 80%+. Traders who use TrackR checklists average 2.3× more profit per month.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function BacktestPreview() {
  const [activeMode, setActiveMode] = useState("auto");
  return (
    <div className="fp-wrap">
      <div className="fp-dash-header">
        <div className="fp-eyebrow-row"><span className="fp-pip" /><span className="fp-eyebrow-text">BACKTESTING</span></div>
        <div className="fp-title-row">
          <span className="fp-page-title">Test Before <em>Risking</em></span>
        </div>
      </div>
    

      <div className="fp-bt-tabs">
        <button className={`fp-bt-tab ${activeMode==="auto"?"active":""}`} onClick={()=>setActiveMode("auto")}>
          <Ico d={I.zap} size={12} color="currentColor" sw={2} /> Automated Strategies
        </button>
        <button className={`fp-bt-tab ${activeMode==="manual"?"active":""}`} onClick={()=>setActiveMode("manual")}>
          <Ico d={I.eye} size={12} color="currentColor" sw={1.75} /> Manual Bar-by-Bar
        </button>
      </div>

      {activeMode === "auto" ? (
        <div>
          <div className="fp-bt-strategy-chips">
            {["EMA Cross","RSI Reversal","Breakout","VWAP Bounce","London Open","Golden Cross","ICT Concepts","Supply/Demand"].map(s => (
              <span key={s} className="fp-bt-chip">{s}</span>
            ))}
          </div>
          <div className="fp-bt-results-list">
            <div className="fp-bt-results-header">
              <span>Strategy</span><span>Win Rate</span><span>Avg R:R</span><span>Profit Factor</span><span>Result</span>
            </div>
            {[
              {s:"London Open", wr:"71%",rr:"2.1",pf:"2.34",c:"green",res:"Strong Edge"},
              {s:"EMA Cross",   wr:"58%",rr:"1.8",pf:"1.62",c:"cyan", res:"Good Edge"},
              {s:"RSI Reversal",wr:"44%",rr:"1.2",pf:"0.94",c:"red",  res:"No Edge"},
            ].map((r,i) => (
              <div className="fp-bt-result-row" key={i}>
                <span className="fp-bt-strat-name">{r.s}</span>
                <span className={r.c}>{r.wr}</span>
                <span>{r.rr}</span>
                <span className={r.c}>{r.pf}</span>
                <span className={`fp-bt-result-badge fp-bt-${r.c}`}>{r.res}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div>
          <div className="fp-bt-chart-area">
            <p className="fp-chart-title" style={{marginBottom:6}}>Bar-by-Bar Replay · EURUSD H1</p>
            <svg viewBox="0 0 460 90" width="100%" height="90" preserveAspectRatio="none">
              {[
                [20,45,30,55,42],[44,35,25,50,32],[68,38,28,48,30],[92,42,32,55,38],
                [116,28,18,45,25],[140,32,22,42,28],[164,22,14,36,20],[188,26,16,38,22],
                [212,18,10,30,16],[236,14,8,24,12],[260,20,12,32,18],[284,16,10,28,14],
                [308,24,14,36,20],[332,18,12,30,16],[356,12,6,22,10],[380,8,4,16,6],
              ].map(([x,h,b,wick_h,wick_b],i) => (
                <g key={i}>
                  <line x1={x} y1={wick_b} x2={x} y2={wick_h} stroke={i<8?"rgba(248,113,113,0.7)":"rgba(52,211,153,0.7)"} strokeWidth="1" />
                  <rect x={x-8} y={b} width={16} height={h-b} rx={1} fill={i<8?"rgba(248,113,113,0.6)":"rgba(52,211,153,0.6)"} />
                </g>
              ))}
              <line x1="332" y1="0" x2="332" y2="90" stroke="rgba(250,204,21,0.7)" strokeWidth="1.5" strokeDasharray="4 3" />
              <text x="336" y="12" fill="#facc15" fontSize="8" fontFamily="monospace">NOW</text>
              <line x1="236" y1="0" x2="236" y2="90" stroke="rgba(34,211,238,0.5)" strokeWidth="1" strokeDasharray="3 2" />
              <text x="240" y="85" fill="rgba(34,211,238,0.8)" fontSize="8" fontFamily="monospace">ENTRY</text>
            </svg>
            <p className="fp-bt-replay-note">Draw S/R levels · Place trades · Advance bar by bar · Measure your real edge</p>
          </div>
        </div>
      )}
    </div>
  );
}

function TerminalPreview() {
  return (
    <div className="fp-wrap">
      <div className="fp-dash-header">
        <div className="fp-eyebrow-row"><span className="fp-pip" /><span className="fp-eyebrow-text">TRACKR TERMINAL</span></div>
        <div className="fp-title-row">
          <span className="fp-page-title">Live Market <em>Intelligence</em></span>
          <span className="fp-live-badge"><span className="fp-live-dot" />6 live feeds</span>
        </div>
      </div>

      <div className="fp-metrics-grid">
        {[
          { l: "WTI Crude",         v: "$78.42", c: "green" },
          { l: "BTC/USDT Buy Vol",  v: "58.2%",  c: "green" },
          { l: "Global Escalation", v: "34/100", c: "cyan"  },
          { l: "Fear & Greed",      v: "62",     c: "green" },
          { l: "Quakes (24h)",      v: "126",    c: ""      },
          { l: "Aircraft Tracked",  v: "1,842",  c: "cyan"  },
          { l: "Fed Funds Rate",    v: "4.33%",  c: ""      },
          { l: "Large Orders",      v: "17",     c: "red"   },
        ].map((m) => (
          <div className="fp-metric-card" key={m.l}>
            <span className="fp-metric-label">{m.l}</span>
            <span className={`fp-metric-val ${m.c}`}>{m.v}</span>
          </div>
        ))}
      </div>

      <div className="fp-chart-duo">
        <div className="fp-chart-card">
          <p className="fp-chart-title">Order Flow · BTC/USDT</p>
          <p className="fp-chart-sub">Footprint delta, live from the tape</p>
          <svg viewBox="0 0 240 80" width="100%" height="80" preserveAspectRatio="none">
            <line x1="0" y1="40" x2="240" y2="40" stroke="rgba(56,189,248,0.15)" strokeDasharray="3 3" />
            <path d="M0,55 L24,48 L48,52 L72,32 L96,38 L120,20 L144,28 L168,14 L192,24 L216,10 L240,18"
              fill="none" stroke="rgba(0,255,170,0.9)" strokeWidth="2" />
            <path d="M0,55 L24,60 L48,62 L72,58 L96,64 L120,60 L144,66 L168,62 L192,68 L216,64 L240,70"
              fill="none" stroke="rgba(255,85,128,0.75)" strokeWidth="2" />
          </svg>
        </div>
        <div className="fp-chart-card">
          <p className="fp-chart-title">Global Risk Map</p>
          <p className="fp-chart-sub">Conflict-zone volume, GDELT-derived</p>
          <svg viewBox="0 0 240 80" width="100%" height="80">
            {[[30,"#ef4444"],[70,"#f97316"],[110,"#facc15"],[150,"#22c55e"],[190,"#facc15"],[215,"#22c55e"]].map(([x,c],i)=>(
              <circle key={i} cx={x} cy={40} r={12} fill={c} opacity="0.75" />
            ))}
          </svg>
        </div>
      </div>

      <div className="fp-insight-popup">
        <div className="fp-insight-header">
          <span className="fp-insight-icon green"><Ico d={I.trending} size={14} color="#00ffaa" sw={2} /></span>
          <span className="fp-insight-verdict green">Everything a desk trader watches, in one screen</span>
        </div>
        <div className="fp-insight-lines">
          <div className="fp-insight-line fp-insight-stat">
            <span className="fp-insight-num">01</span>
            <p>Live order flow, footprint charts and large-order tape across BTC, ETH and majors — updated every few seconds.</p>
          </div>
          <div className="fp-insight-line fp-insight-stat">
            <span className="fp-insight-num">02</span>
            <p>Real-time aircraft tracking, earthquake alerts, shipping chokepoints and conflict-volume risk scoring — the same signals macro desks watch.</p>
          </div>
          <div className="fp-insight-line fp-insight-action">
            <span className="fp-insight-num">03</span>
            <p><Ico d={I.zap} size={12} color="#22d3ee" sw={2} style={{display:"inline",marginRight:6}} /> Central bank rates, COT positioning, and live oil & FX — context most journals never give you.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── FEATURES ────────────────────────────────────────────────────────────────
const FEATURES = [
  {
    id: "dashboard",
    icon: I.chart,
    title: "Analytics Dashboard",
    tagline: "Every metric that matters. Nothing that doesn't.",
    accent: "#22d3ee",
    accentRgb: "34,211,238",
    tag: "Core",
    tagColor: "cyan",
    killer: "Clickable breakdowns on every chart and metric — not just data, but what it means and what to do about it",
    edge: "Most journals dump charts and leave you to figure it out. TrackR surfaces the pattern, explains it in plain language, and gives you a concrete next step.",
    preview: <DashboardPreview />,
  },
  {
    id: "pnl",
    icon: I.calendar,
    title: "P&L Calendar",
    tagline: "See your entire month at a glance.",
    accent: "#34d399",
    accentRgb: "52,211,153",
    tag: "Core",
    tagColor: "cyan",
    killer: "Daily P&L cells with trade count, win count per day, weekly totals, and MT5 synced trades marked inline",
    edge: "You get total P&L, day win rate, trade win rate, best day, worst day, and weekly rollups — all in one screen without any extra clicks.",
    preview: <PnlCalendarPreview />,
  },
  {
    id: "review",
    icon: I.brain,
    title: "Trade Review",
    tagline: "Deep analytics sliced every way you need.",
    accent: "#818cf8",
    accentRgb: "129,140,248",
    tag: "Core",
    tagColor: "indigo",
    killer: "Win rate, P&L, and efficiency broken down by strategy, emotion, session, and asset class — plus a per-trade score on every card",
    edge: "TrackR tells you that you win 71% when calm but only 24% when anxious, and shows you exactly how much that costs. That's the kind of pattern that changes behaviour.",
    preview: <TradeReviewPreview />,
  },
  {
    id: "equity",
    icon: I.trending,
    title: "Performance Graph",
    tagline: "Watch your account grow trade by trade.",
    accent: "#00ffaa",
    accentRgb: "0,255,170",
    tag: "Core",
    tagColor: "cyan",
    killer: "Filter by year or month, start from $0 or your real balance, plus all-time best pair/month/year tracked automatically",
    edge: "The curve covers both manual and MT5 trades in one view. Hover any point to see the exact trade behind every peak and drawdown.",
    preview: <EquityCurvePreview />,
  },
  {
    id: "mt5",
    icon: I.sync,
    title: "MT5 Auto-Sync",
    tagline: "Your broker logs your trades. TrackR analyzes them.",
    accent: "#a78bfa",
    accentRgb: "167,139,250",
    tag: "Pro+",
    tagColor: "violet",
    killer: "Connect once and every trade you take in MT5 appears in TrackR automatically — no copy-pasting, no manual entry, ever",
    edge: "MT5 trades merge with your manual journal seamlessly. One combined equity curve, one dashboard, one truth.",
    preview: <MT5Preview />,
  },
  {
    id: "backtest",
    icon: I.zap,
    title: "Backtesting",
    tagline: "Test ideas before risking real money.",
    accent: "#f59e0b",
    accentRgb: "245,158,11",
    tag: "Pro",
    tagColor: "indigo",
    killer: "12 automated strategies plus full bar-by-bar manual replay with drawing tools and real indicators",
    edge: "Don't just run a backtest — replay your actual charts, draw your levels, and see whether your setups would have worked before you risk a cent.",
    preview: <BacktestPreview />,
  },
  {
    id: "scores",
    icon: I.target,
    title: "MEQU & TrackR Scores",
    tagline: "Two scores. Complete picture of your trading.",
    accent: "#22d3ee",
    accentRgb: "34,211,238",
    tag: "Core",
    tagColor: "cyan",
    killer: "TrackR Score measures outcomes across 6 dimensions. MEQU measures psychology across 5. Together they pinpoint exactly what's costing you.",
    edge: "No other journal quantifies your psychological performance with a score that updates after every single trade logged.",
    preview: <ScoresPreview />,
  },
  {
    id: "playbook",
    icon: I.book,
    title: "Playbook + Checklists",
    tagline: "Document your edge. Never deviate from it.",
    accent: "#34d399",
    accentRgb: "52,211,153",
    tag: "Core",
    tagColor: "cyan",
    killer: "Linked playbook and pre-trade checklist — you gate every entry against your own rules before logging the trade",
    edge: "Rules that live in a doc? Discipline stays at 55%. Rules that gate every entry? Discipline hits 80%+. The checklist is the difference.",
    preview: <PlaybookPreview />,
  },
  {
    id: "terminal",
    icon: I.zap,
    title: "TrackR Terminal",
    tagline: "A live market intelligence desk, built into your journal.",
    accent: "#00d9ff",
    accentRgb: "0,217,255",
    tag: "Pro+",
    tagColor: "violet",
    killer: "Live order flow, footprint charts, global risk mapping, real-time aircraft & earthquake tracking, and central bank data — all updating in real time",
    edge: "No other trading journal ships a live intelligence terminal. Order flow, geopolitical risk, oil prices, and macro data sit next to your own trade history — so market context and your performance live in the same place.",
    preview: <TerminalPreview />,
  },
];

const TAG_COLORS = {
  cyan:   { bg: "rgba(34,211,238,0.08)",  border: "rgba(34,211,238,0.25)",  text: "#22d3ee" },
  indigo: { bg: "rgba(99,102,241,0.08)",  border: "rgba(99,102,241,0.25)",  text: "#818cf8" },
  violet: { bg: "rgba(167,139,250,0.08)", border: "rgba(167,139,250,0.25)", text: "#a78bfa" },
};

function FeatureModal({ feature, onClose }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);
  return (
    <div className="feat-modal-overlay" onClick={onClose}>
      <div className="feat-modal" onClick={e => e.stopPropagation()}>
        <button className="feat-modal-close" onClick={onClose}>
          <Ico d={I.close} size={16} color="#94a3b8" sw={2.5} />
        </button>
        <div className="feat-modal-header" style={{ borderColor: `rgba(${feature.accentRgb},0.2)` }}>
          <div className="feat-modal-icon-wrap" style={{ background: `rgba(${feature.accentRgb},0.1)`, border: `1px solid rgba(${feature.accentRgb},0.25)` }}>
            <Ico d={feature.icon} size={22} color={feature.accent} sw={1.5} />
          </div>
          <div>
            <h2 className="feat-modal-title" style={{ color: feature.accent }}>{feature.title}</h2>
            <p className="feat-modal-tagline">{feature.tagline}</p>
          </div>
        </div>

        <div className="feat-modal-preview">
          {feature.preview}
        </div>

        <div className="feat-modal-body">
          <div className="feat-modal-killer">
            <Ico d={I.zap} size={14} color={feature.accent} sw={2} />
            <div>
              <p className="feat-modal-killer-label">WHAT MAKES IT WORK</p>
              <p className="feat-modal-killer-text">{feature.killer}</p>
            </div>
          </div>
          <div className="feat-modal-diff">
            <Ico d={I.trending} size={14} color="#94a3b8" sw={1.75} />
            <div>
              <p className="feat-modal-diff-label">OUR EDGE</p>
              <p className="feat-modal-diff-text">{feature.edge}</p>
            </div>
          </div>
        </div>

        <button
          className="feat-modal-cta btn-primary"
          style={{
            background: `linear-gradient(135deg, rgba(${feature.accentRgb},0.8), rgba(${feature.accentRgb},0.4))`,
            color: "#000"
          }}
          onClick={goSignup}
        >
          Get {feature.title} free →
        </button>
      </div>
    </div>
  );
}

function ScreenshotShowcase() {
  const shots = [
    {
      tag: "P&L CALENDAR",
      title: "See your entire month",
      em: "at a glance.",
      desc: "Every trading day with P&L, trade count, win count, and weekly rollups. Instantly spot your best sessions, worst days, and the patterns costing you most.",
      img: "/screenshots/calender.png",
      accent: "#34d399",
      accentRgb: "52,211,153",
      pills: ["Day Win Rate","Weekly Totals","Trade Count","Best & Worst Day"],
      align: "left",
    },
    {
      tag: "TRADE HISTORY",
      title: "Every trade logged.",
      em: "Every detail tracked.",
      desc: "Full table with entry, exit, SL, TP, psychology state, efficiency score, outcome badge and P&L. MT5 auto-synced trades appear automatically — no manual entry ever.",
      img: "/screenshots/tradelist.png",
      accent: "#818cf8",
      accentRgb: "129,140,248",
      pills: ["Efficiency Score","Psychology","MT5 Auto-Sync","Outcome Badges"],
      align: "right",
    },
    {
      tag: "AI INSIGHTS",
      title: "Patterns you'd never",
      em: "find yourself.",
      desc: "TrackR detects behavioral patterns across your trades — leaving gains on the table, emotional entries, risk violations — and gives you the exact dollar cost and what to change.",
      img: "/screenshots/insights.png",
      accent: "#f59e0b",
      accentRgb: "245,158,11",
      pills: ["Pattern Detection","Dollar Impact","Actionable Fix","Psychology Analysis"],
      align: "left",
    },
    {
      tag: "TRADE DETAIL",
      title: "Every trade dissected.",
      em: "Entry to psychology.",
      desc: "Click any trade for the full breakdown — entry/exit, session, planned vs realized RR, rules followed, emotion state, and a live behavior radar showing exactly how you executed.",
      img: "/screenshots/tradedetail.png",
      accent: "#a78bfa",
      accentRgb: "167,139,250",
      pills: ["Behavior Radar","Rules Followed","Realized RR","Emotion State"],
      align: "right",
    },
    {
      tag: "TRADER SCORE & PROGRESS",
      title: "Your trading level.",
      em: "Quantified.",
      desc: "TrackR Score combines win rate, efficiency, and journaling consistency into one number. Watch it climb as your discipline improves — intermediate to advanced, tracked automatically.",
      img: "/screenshots/traderscore.png",
      accent: "#22d3ee",
      accentRgb: "34,211,238",
      pills: ["Trader Score","Win Rate","Efficiency","Consistency","Progress Level"],
      align: "right",
    },
    {
      tag: "BAR-BY-BAR REPLAY",
      title: "Replay any market.",
      em: "Trade it again.",
      desc: "Full candlestick replay with EMA, VWAP, RSI, MACD and more. Place Long or Short at any bar, advance step by step, and measure your real edge before risking a cent.",
      img: "/screenshots/replay.png",
      accent: "#f59e0b",
      accentRgb: "245,158,11",
      pills: ["Live Indicators","Long & Short","Bar-by-Bar","Real Candles","PRO Charts"],
      align: "left",
    },
    {
      tag: "BACKTEST RESULTS",
      title: "See exactly which",
      em: "strategies have edge.",
      desc: "Full results dashboard with total P&L, win rate, max drawdown, profit factor, final equity, price chart with entries/exits marked, equity curve, and complete trade log.",
      img: "/screenshots/backtestchart.png",
      accent: "#34d399",
      accentRgb: "52,211,153",
      pills: ["+157% P&L","66.7% Win Rate","Max Drawdown","Trade Log","Equity Curve"],
      align: "right",
    },
    {
      tag: "KNOWLEDGE & JOURNAL",
      title: "Build your trading",
      em: "knowledge base.",
      desc: "Goals, vision board, daily journal, weekly review, and knowledge folders — all in one place. The mental side of trading tracked alongside the numbers.",
      img: "/screenshots/knowledge.png",
      accent: "#a78bfa",
      accentRgb: "167,139,250",
      pills: ["Daily Journal","Goals","Vision Board","Weekly Review","Knowledge Folders"],
      align: "left",
    },
    {
      tag: "TRADE REVIEW",
      title: "Slice your data",
      em: "every way that matters.",
      desc: "Filter by strategy, emotion, session, and asset class. See best/worst symbol and strategy. Every card has a live efficiency score so you know execution quality beyond just P&L.",
      img: "/screenshots/tradereview.png",
      accent: "#22d3ee",
      accentRgb: "34,211,238",
      pills: ["Filter by Emotion","Best Symbol","Win Rate by Strategy","Score per Trade"],
      align: "left",
    },
    {
      tag: "ANALYTICS DASHBOARD",
      title: "Every metric that matters.",
      em: "Nothing that doesn't.",
      desc: "Win rate, P&L, profit factor, equity curve, and daily bar chart — all in one view. Clickable breakdowns surface the pattern, explain it in plain language, and give you a concrete next step.",
      img: "/screenshots/dashboard.png",
      accent: "#22d3ee",
      accentRgb: "34,211,238",
      pills: ["Win Rate","Cumulative P&L","Expected vs Realized","Pattern Detection"],
      align: "right",
      badge: { label: "⚠ Pattern Detected", text: "Anxious trades: 24% win rate vs 71% when calm", color: "#ef4444" },
    },
    {
      tag: "TRACKR TERMINAL",
      title: "Live order flow, global risk,",
      em: "and market intel in one screen.",
      desc: "Real-time order flow and footprint charts, live vessel & aircraft tracking, earthquake alerts, shipping chokepoints, oil prices, and central bank data — a full market intelligence desk built right into your journal.",
      img: "/screenshots/terminal.png",
      accent: "#00d9ff",
      accentRgb: "0,217,255",
      pills: ["Live Order Flow","Aircraft Tracking","Earthquakes","Global Risk Map","Oil & Macro Data"],
      align: "left",
    },
  ];

  return (
    <section className="mkt-section" id="showcase">
      <div className="mkt-section__inner">
        <p className="eyebrow reveal"><Ico d={I.pip} size={8} color="#22d3ee" sw={3} />INSIDE TRACKR</p>
        <h2 className="section-title reveal">Real screenshots. <em>Real data.</em></h2>
        <p className="section-sub reveal">This is what your dashboard actually looks like — not mockups, not demos.</p>
        <div className="showcase-list">
          {shots.map((s, i) => (
            <div key={s.tag} className={`showcase-row reveal ${s.align === "right" ? "showcase-row--flip" : ""}`} style={{animationDelay:`${i*0.1}s`}}>
              <div className="showcase-img-wrap" style={{borderColor:`rgba(${s.accentRgb},0.25)`}}>
                <div className="showcase-img-bar" style={{background:`linear-gradient(90deg,transparent,rgba(${s.accentRgb},0.7),transparent)`}} />
                <div className="showcase-img-dots">
                  <span style={{background:"#ef4444",width:10,height:10,borderRadius:"50%",display:"inline-block"}} />
                  <span style={{background:"#f59e0b",width:10,height:10,borderRadius:"50%",display:"inline-block"}} />
                  <span style={{background:"#22c55e",width:10,height:10,borderRadius:"50%",display:"inline-block"}} />
                  <span className="showcase-img-url">app.trackr.io</span>
                </div>
                <img
                  src={s.img}
                  alt={s.tag}
                  className="showcase-img"
                  onError={e => { e.currentTarget.style.opacity="0.1"; }}
                />
                <div className="showcase-img-shine" style={{background:`linear-gradient(135deg,rgba(${s.accentRgb},0.06),transparent 60%)`}} />
                {s.badge && (
                  <div style={{position:"absolute",bottom:12,right:12,background:"rgba(13,21,32,0.97)",border:`1px solid rgba(239,68,68,0.3)`,borderRadius:12,padding:"10px 14px",maxWidth:220,boxShadow:"0 8px 32px rgba(0,0,0,0.6)"}}>
                    <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"#ef4444",fontWeight:700,marginBottom:4,textTransform:"uppercase",letterSpacing:"0.1em"}}>{s.badge.label}</div>
                    <div style={{fontFamily:"'Inter',sans-serif",fontSize:11,color:"#94a3b8",lineHeight:1.5}}>{s.badge.text}</div>
                  </div>
                )}
              </div>
              <div className="showcase-text">
                <div className="showcase-tag" style={{color:`rgba(${s.accentRgb},0.9)`,borderColor:`rgba(${s.accentRgb},0.2)`,background:`rgba(${s.accentRgb},0.06)`}}>
                  <Ico d={I.pip} size={6} color={s.accent} sw={3} />
                  {s.tag}
                </div>
                <h3 className="showcase-title">
                  {s.title}<br />
                  <em style={{fontStyle:"normal",background:`linear-gradient(100deg,${s.accent},rgba(${s.accentRgb},0.5))`,WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>{s.em}</em>
                </h3>
                <p className="showcase-desc">{s.desc}</p>
                <div className="showcase-pills">
                  {s.pills.map(p => (
                    <span key={p} className="showcase-pill" style={{borderColor:`rgba(${s.accentRgb},0.25)`,color:`rgba(${s.accentRgb},0.8)`}}>{p}</span>
                  ))}
                </div>
                <button className="btn-outline showcase-cta" style={{borderColor:`rgba(${s.accentRgb},0.4)`,color:s.accent,background:`rgba(${s.accentRgb},0.06)`,marginTop:8}} onClick={goSignup}>
                  Try it free →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Features() {
  const [openFeature, setOpenFeature] = useState(null);
  return (
    <section className="mkt-section" id="features">
      <div className="mkt-section__inner">
        <p className="eyebrow reveal"><Ico d={I.pip} size={8} color="#22d3ee" sw={3} />EVERYTHING YOU NEED</p>
        <h2 className="section-title reveal">One platform. <em>Unlimited edge.</em></h2>
        <p className="section-sub reveal">Click any feature to see it in action — real previews, real data.</p>
        <div className="features-grid">
          {FEATURES.map((f, i) => {
            const tc = TAG_COLORS[f.tagColor];
            return (
              <div
                className="feature-card glass-card reveal"
                key={f.id}
                style={{ animationDelay: `${i * 0.07}s`, cursor: "pointer" }}
                onClick={() => setOpenFeature(f)}
              >
                <div className="feature-card__top">
                  <div className="feature-icon-wrap" style={{ background: `rgba(${f.accentRgb},0.1)`, border: `1px solid rgba(${f.accentRgb},0.2)` }}>
                    <Ico d={f.icon} size={18} color={f.accent} sw={1.75} />
                  </div>
                  <span className="feature-tag" style={{ background: tc.bg, border: `1px solid ${tc.border}`, color: tc.text }}>{f.tag}</span>
                </div>
                <h3 style={{ color: "#dff0f8" }}>{f.title}</h3>
                <p style={{ color: "#7a9ab0", fontSize: "0.88rem", lineHeight: 1.65, marginBottom: 12 }}>{f.tagline}</p>
                <div className="feature-card-cta" style={{ color: f.accent }}>
                  <span>See it in action</span>
                  <Ico d={I.arrowR} size={13} color={f.accent} sw={2} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {openFeature && <FeatureModal feature={openFeature} onClose={() => setOpenFeature(null)} />}
    </section>
  );
}

function HowItWorks() {
  const STEPS = [
    { num: "01", icon: I.check,    title: "Sign up & connect",      desc: "Create your free account in 30 seconds. Optionally connect MT5 for automatic trade imports." },
    { num: "02", icon: I.journal,  title: "Log & tag every trade",  desc: "Quick log or advanced form. Tag strategy, emotion, session, timeframe. Screenshots included." },
    { num: "03", icon: I.trending, title: "Let the data guide you", desc: "Your dashboard surfaces patterns, scores execution, and tells you exactly where to improve." },
  ];
  return (
    <section className="mkt-section mkt-section--alt" id="how">
      <div className="mkt-section__inner">
        <p className="eyebrow reveal"><Ico d={I.pip} size={8} color="#22d3ee" sw={3} />THE PROCESS</p>
        <h2 className="section-title reveal">Three steps to <em>consistent profits.</em></h2>
        <div className="steps-row">
          {STEPS.map((s, i) => (
            <div className="step-card glass-card reveal" key={s.num} style={{ animationDelay: `${i * 0.12}s` }}>
              <div className="step-icon-wrap"><Ico d={s.icon} size={20} color="#22d3ee" sw={1.75} /></div>
              <span className="step-num">{s.num}</span>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              {i < STEPS.length - 1 && <span className="step-arrow">→</span>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const PLANS = [
  {
    id:"free", name:"Free", price:"$0", period:"forever", desc:"Start tracking your edge",
    accent:"rgba(100,160,180,1)", accentRgb:"100,160,180", icon:I.chart,
    features:[{t:"20 trades lifetime",ok:true},{t:"Quick log",ok:true},{t:"1 Playbook",ok:true},{t:"Core analytics",ok:true},{t:"Advanced log",ok:false},{t:"MT5 sync",ok:false},{t:"Backtesting",ok:false},{t:"TrackR Terminal",ok:false}],
    cta:"Start for free", ctaStyle:"outline", note:"No card required",
  },
  {
    id:"pro", name:"Pro", price:"$4.99", period:"/month", desc:"For the serious trader",
    accent:"rgba(34,211,238,1)", accentRgb:"34,211,238", icon:I.zap, highlight:true, badge:"MOST POPULAR",
    features:[{t:"Unlimited trades",ok:true},{t:"Advanced log",ok:true},{t:"MT5 auto-sync",ok:true},{t:"5 Playbooks",ok:true},{t:"20 auto + 20 manual backtests/mo",ok:true},{t:"CSV export",ok:true},{t:"Full analytics + scores",ok:true},{t:"TrackR Terminal",ok:true}],
    cta:"Get Pro →", ctaStyle:"primary", note:"Cancel anytime",
  },
  {
    id:"proplus", name:"Pro+", price:"$9.99", period:"/month", desc:"No limits. No compromises.",
    accent:"rgba(167,139,250,1)", accentRgb:"167,139,250", icon:I.crown, badge:"UNLIMITED",
    features:[{t:"Everything in Pro",ok:true},{t:"Unlimited backtests",ok:true},{t:"Unlimited Playbooks",ok:true},{t:"Priority support",ok:true},{t:"Early feature access",ok:true},{t:"TrackR Terminal",ok:true}],
    cta:"Get Pro+ →", ctaStyle:"outline-accent", note:"Cancel anytime",
  },
  {
    id:"lifetime", name:"Lifetime", price:"$99.99", period:"one-time", desc:"Everything, forever.",
    accent:"rgba(251,191,36,1)", accentRgb:"251,191,36", icon:I.crown, badge:"LIMITED TIME SALE", sale:true,
    features:[{t:"Everything in Pro+",ok:true},{t:"Unlimited backtests",ok:true},{t:"Unlimited Playbooks",ok:true},{t:"Priority support",ok:true},{t:"Early feature access",ok:true},{t:"TrackR Terminal",ok:true},{t:"No monthly billing, ever",ok:true}],
    cta:"Get Lifetime →", ctaStyle:"outline-accent", note:"One payment, no renewals",
  },
];

function PricingCard({ plan, index }) {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [hovered, setHovered] = useState(false);
  const cardRef = useRef(null);
  const handleMouseMove = (e) => {
    const rect = cardRef.current.getBoundingClientRect();
    setMousePos({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };
  return (
    <div ref={cardRef}
      className={`prc-card reveal ${plan.highlight ? "prc-card--highlight" : ""}`}
      style={{ animationDelay: `${index * 0.12}s` }}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {hovered && <div className="prc-spotlight" style={{ background: `radial-gradient(300px circle at ${mousePos.x}px ${mousePos.y}px, rgba(${plan.accentRgb},0.1), transparent 70%)` }} />}
      <div className="prc-topline" style={{ background: `linear-gradient(90deg, transparent, ${plan.accent}, transparent)`, opacity: plan.highlight ? 1 : 0.5 }} />
      {plan.badge && (
        <div className={`prc-badge ${plan.sale ? "prc-badge--flash" : ""}`} style={{ background: `rgba(${plan.accentRgb},0.12)`, border: `1px solid rgba(${plan.accentRgb},0.3)`, color: plan.accent }}>
          <Ico d={plan.highlight ? I.zap : I.crown} size={10} color={plan.accent} sw={2.5} />
          {plan.badge}
        </div>
      )}
      <div className="prc-name" style={{ color: plan.accent }}>{plan.name}</div>
      <div className="prc-desc">{plan.desc}</div>
      <div className="prc-price-row">
      
<span className="prc-amount" style={{ color: plan.accent }}>{plan.price}</span>
        <span className="prc-period">{plan.period}</span>
      </div>
      <div className="prc-divider" style={{ background: `linear-gradient(90deg, transparent, rgba(${plan.accentRgb},0.3), transparent)` }} />
      <ul className="prc-features">
        {plan.features.map((f, i) => (
          <li key={i} className={f.ok ? "" : "prc-feature--dim"}>
            <span className="prc-feature-icon" style={{ background: f.ok ? `rgba(${plan.accentRgb},0.1)` : "rgba(255,255,255,0.03)", border: `1px solid ${f.ok ? `rgba(${plan.accentRgb},0.25)` : "rgba(255,255,255,0.06)"}` }}>
              <Ico d={f.ok ? I.check : I.close} size={10} color={f.ok ? plan.accent : "rgba(255,255,255,0.2)"} sw={2.5} />
            </span>
            {f.t}
          </li>
        ))}
      </ul>
      <button
        className="prc-cta"
        style={plan.ctaStyle === "primary" ? {
          background: `linear-gradient(135deg, rgba(${plan.accentRgb},0.25), rgba(${plan.accentRgb},0.12))`,
          border: `1px solid rgba(${plan.accentRgb},0.5)`, color: plan.accent,
          boxShadow: `0 0 30px rgba(${plan.accentRgb},0.15)`,
        } : { background: `rgba(${plan.accentRgb},0.06)`, border: `1px solid rgba(${plan.accentRgb},0.3)`, color: plan.accent }}
        onClick={goPricing}
      >
        <span>{plan.cta}</span>
        {plan.highlight && <span className="prc-cta-pulse" style={{ background: plan.accent }} />}
      </button>
      <p className="prc-note">{plan.note}</p>
    </div>
  );
}

function Pricing() {
  return (
    <section className="mkt-section" id="pricing">
      <div className="mkt-section__inner">
        <p className="eyebrow reveal"><Ico d={I.pip} size={8} color="#22d3ee" sw={3} />PRICING</p>
        <h2 className="section-title reveal">Simple pricing. <em>Real results.</em></h2>
        <p className="section-sub reveal">Start free. Upgrade when you're ready.</p>
        <div className="prc-grid">          {PLANS.map((plan, i) => <PricingCard key={plan.id} plan={plan} index={i} />)}
        </div>
        <div className="prc-bottom reveal">
          <div className="prc-bottom__shield">
            <Ico d={I.shield} size={16} color="rgba(34,211,238,0.6)" />
            <div>
              <p className="prc-bottom__shield-title">Secure & risk-free</p>
              <p className="prc-bottom__shield-sub">Cancel anytime · Payments via Gumroad · Your data is always yours</p>
            </div>
          </div>
          <button className="btn-primary btn-lg prc-bottom__btn" onClick={goPricing}>
            See full plan details & get started →
          </button>
        </div>
      </div>
    </section>
  );
}

function FinalCTA() {
  return (
    <section className="mkt-cta-section">
      <div className="mkt-cta-section__inner">
        <p className="eyebrow reveal"><Ico d={I.pip} size={8} color="#22d3ee" sw={3} />GET STARTED TODAY</p>
        <h2 className="section-title reveal">Your edge is in <em>the data.</em></h2>
        <p className="section-sub reveal">Join traders who've stopped guessing and started improving. Free forever. No card needed.</p>
        <button className="btn-primary btn-lg reveal" onClick={goSignup}>Create your free account →</button>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="mkt-footer">
      <div className="mkt-footer__inner">
        <span className="mkt-nav__logo">TRACK<em>R</em></span>
        <p className="mkt-footer__copy">© {new Date().getFullYear()} TrackR. Built for traders, by traders.</p>
        <div className="mkt-footer__links">
          <button className="btn-ghost btn-sm" onClick={goLogin}>Log in</button>
        </div>
      </div>
    </footer>
  );
}

export default function MarketingLandingPage() {
  useReveal();
  return (
    <div className="mkt-root">
      <PromoBar />
      <div className="orb orb--cyan" />
      <div className="orb orb--indigo" />
      <div className="grid-texture" />
      <Nav />
      <StatsStrip />
      <Hero />
      <Pricing />
      <ScreenshotShowcase />
      <Features />
      <HowItWorks />
      <FinalCTA />
      <Footer />
    </div>
  );
}